import { useEffect, useMemo, useState } from "react";

import {
  Autocomplete,
  Checkbox,
  InputAdornment,
  TextField,
} from "@mui/material";
import { format } from "date-fns";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import TableDropDownField from "../../../../common/components/FormFields/TableDropDownField";
import SearchIcon from "@mui/icons-material/Search";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import {
  fetchBatchNoList,
  fetchCssdItems,
  fetchCssdItemsTransferOT,
  fetchCssdKitItemById,
  fetchCssdStockByIdAndBatch,
  fetchIndentData,
  fetchitemkfromkit,
  fetchTransferCssdItemsKitList,
  fetchTransferCssdItemsKitListCSSDRe,
  fetchTransferCssdItemsList,
  fetchTransferReceiveCssdItemsList,
  fetchTransferReceiveCssdItemsListOT,
  saveCssdIndentDetails,
  saveTransferCssdItemsList,
  saveTransferCssdItemsListStock,
  saveTransferCssdItemsListTransfer,
  saveTransferCssdItemsListTransferOT,
} from "../../../services/transferReceiveCssdServices/TransferReceiveCssdServices";
import IssueReceiveCSSDModal from "./TransferReceiveCSSDModal";
import { useGetUserActions } from "../../../../common/components/Custom Hooks/useGetUserActions";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import SearchBar from "../../../../common/components/FormFields/SearchBar";
import CommonTransactionTable from "../../../../common/components/CommonTable/CommonTransactionTable";
import { UseCheckConsecutiveCharacters } from "../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import { getStoreDropdown } from "../../../services/commonservices/commonservices";

const screenType = ["CSSD Kit Request", "Transfer", "Receive"];
const itemType = [
  { label: "Kit", value: "Kit", id: "Kit" },
  { label: "Item", value: "Item", id: "Item" },
];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const TransferReceiveCSSD = (user, value, onChange) => {
  const location = useLocation();
  const getUserInfo = JSON.parse(localStorage?.getItem("userInfo"));
  console.log("getUserInfogetUserInfogetUserInfo",getUserInfo);
  
      const [selectedRole, setSelectedRole] = useState(""); // OT or CSSD
  const [transferReceiveItemsList, setTransferReceiveItemsList] = useState([]);
  const [transferReceiveKitList, setTransferReceiveKitList] = useState([]);
  const [transferReceiveKitItemsList, setTransferReceiveKitItemsList] =
    useState([]);
  const [page, setPage] = useState(0);
  const [kitPage, setKitPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [kitRowsPerPage, setKitRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [kitCount, setKitCount] = useState(null);
  const [openPreviousListModal, setOpenPreviousListModal] = useState(false);
  const [openPostModal, setOpenPostModal] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  // const [selectedScreen, setSelectedScreen] = useState(
  //   location?.pathname?.includes("issuereceive") ? "Receive" : "CSSD Kit Request"
  // );
  const [transferOTKitList, setTransferOTKitList] = useState([]);
  const [searchBarString, setSearchBarString] = useState("");

  const [transferCSSDList, setTransferCSSDList] = useState([]);
  const [transferPage, setTransferPage] = useState(0);
  const [transferRowsPerPage, setTransferRowsPerPage] = useState(10);
  const [transferCount, setTransferCount] = useState(0);

  const [userActions, setUserActions] = useState([]);
  const [kitItemOption, setKitItemOption] = useState("kit");
  const [showConfirm, setShowConfirm] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [setGetItemType] = useState("Kit");
  const [usedTransferCSSDItemsList, setUsedTransferCSSDItemsList] = useState([]);
  const [usedPage, setUsedPage] = useState(0);
  const [usedRowsPerPage, setUsedRowsPerPage] = useState(10);
  const [usedCount, setUsedCount] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedToStore, setSelectedToStore] = useState(null);
  const [receiveKitItemsList, setReceiveKitItemsList] = useState([]);

  const [cssdReceiveList, setCssdReceiveList] = useState([]);
  const [cssdReceiveKitItems, setCssdReceiveKitItems] = useState([]);
  const [receiveCssdKitItemsList, setReceiveCssdKitItemsList] = useState([]);
  // const [cssdTab, setCssdTab] = useState(null);
  const [cssdTab, setCssdTab] = useState(receiveCssdKitItemsList?.[0]?.id || null);
  const [selectedCssdKit, setSelectedCssdKit] = useState(null);
  const [cssdReceiveItemList, setCssdReceiveItemList] = useState([]);
  const [indentList, setIndentList] = useState([]);

  // Example value structure
  // selectedToStore = { value: 2, label: "Main Store" }

  const [activeTab, setActiveTab] = useState(0);
  // const [selectedRole, setSelectedRole] = useState("OT"); // OT or CSSD

const filteredTabs =
  selectedRole === "Operation Theatre"
    ? screenType
    : screenType.filter((item) => item !== "CSSD Kit Request");
  
const [selectedScreen, setSelectedScreen] = useState(
  location?.pathname?.includes("issuereceive")
    ? "Receive"
    : "CSSD Kit Request"
);
  const [searchKey, setSearchKey] = useState(0);
  const [options, setOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [itemKitOptions, setItemKitOptions] = useState([]);
  const [checked, setChecked] = useState(false);
  const [listingObject, setListingObject] = useState({
    searchString: null,
    searchId: null,
    fromDate: null,
    toDate: null,
    page: page,
    size: rowsPerPage,
  });
  const [storeOptions, setStoreOptions] = useState([]);
  const defaultValues = {
    fromDate: null,
    toDate: null,
    itemType: "Kit",
    toStore: null,
  };
  const {
    control,
    watch,
    setError,
    clearErrors,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
  });


  const getTransferCSSDData = async () => {
    const payload = {
      searchString: searchString || null,
      page: page,
      size: rowsPerPage,
      fromDate: fromDate || null,
      toDate: toDate || null,
      searchId: null,
      processType: "Transfer",
    };

    try {
      const response = await fetchIndentData(payload);
      if (response?.data?.result) {
        setTransferCSSDList(response.data.result);
      } else {
        setTransferCSSDList([]);
      }
    } catch (err) {
      console.error("Error fetching transfer CSSD data:", err);
      setTransferCSSDList([]);
    }
  };
  const [receiveCssdList, setReceiveCssdList] = useState([]);

  // const handleCssdReceiveFetch = async () => {
  //   try {
  //     const payload = {
  //       searchString: null,
  //       page: 0,
  //       size: 10,
  //       fromDate: null,
  //       toDate: null,
  //       searchId: getStore?.value || null,
  //       processType: "receive",
  //     };

  //     const response = await fetchTransferCssdItemsKitListCSSDRe(payload);

  //     if (response?.data?.statusCode === 200) {
  //       setReceiveCssdList(response.data.result || []);
  //     } else {
  //       setReceiveCssdList([]);
  //     }
  //   } catch (error) {
  //     console.error("Fetch Receive CSSD Error:", error);
  //   }
  // };
  useEffect(() => {
  if (selectedRole === "Operation Theatre") {
    setSelectedScreen("CSSD Kit Request");
  } else if (selectedRole === "Cssd") {
    setSelectedScreen("Transfer");
  }
}, [selectedRole]);


  const handleToStoreChange = (inputValue) => {
    if (typeof inputValue !== "string") return;

    setSearchBarString(inputValue);

    const trimmedValue = inputValue.trim();

    if (
      trimmedValue.length > 0 &&
      UseCheckConsecutiveCharacters(trimmedValue)
    ) {
      getStoreDropdown(trimmedValue)
        .then((res) => {
          setStoreOptions(res?.data?.result ?? []);
        })
        .catch(() => {
          setStoreOptions([]);
        });
    } else {
      setStoreOptions([]);
    }
  };
  useEffect(() => {
  if (getUserInfo?.cashCounter) {
    console.log("sdlskdlfsdfjsldfsdf",getUserInfo?.cashCounter);
    
    setSelectedRole(getUserInfo.cashCounter);
  }
}, [getUserInfo]);
console.log("cashCounter:", getUserInfo?.cashCounter);
console.log("selectedRole:", selectedRole);
  
  const handleCssdReceiveFetch = async () => {
    try {
      const payload = {
        searchString: null,
        page: 0,
        size: 10,
        fromDate: null,
        toDate: null,
        // searchId: getStore?.value || 0,
        searchId: null,
        processType: "receive"
      };

      const response = await fetchTransferCssdItemsKitListCSSDRe(payload);

      if (response?.status === 200) {
        setReceiveCssdList(response?.data?.result || []);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const updatedReceiveCssdList = receiveCssdList?.map((item) => ({
    ...item,
    Select: item.Select || false,
  }));


  // useEffect(() => {
  //   getTransferCSSDData();
  // }, [page, rowsPerPage, searchString, fromDate, toDate]);


  const handleInputChange = (inputValue) => {
    if (!inputValue) return;

    setLoading(true);
    fetchCssdItems(kitItemOption, inputValue)
      .then((res) => {
        const formattedOptions = res.data.result.map((item) => ({
          label: item.label,
          value: item.id
        }));
        setOptions(formattedOptions);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const handleInputChangeTransferOT = (inputValue) => {
    if (!inputValue) return;

    setLoading(true);

    fetchCssdItemsTransferOT(kitItemOption)   // <-- FIXED
      .then((res) => {
        const formattedOptions = res.data.result.map((item) => ({
          label: item.label || item.KitName || item["Item Name"],
          value: item.id,
        }));

        setOptions(formattedOptions);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };



  const handleTransferOT = () => {
    const itemDetailsArray =
      getItemType === "Item"
        ? transferReceiveItemsList?.filter((fil) => fil?.Select)
        : transferReceiveKitItemsList
          ?.flatMap((kit) => kit?.kitItemList)
          ?.filter((fil) => fil?.Select);

    if (!itemDetailsArray?.length) {
      warningAlert("Please select at least one item!");
      return;
    }

    setShowConfirm(true); // open modal
  };


  // const confirmTransferOT = async () => {
  //   setShowConfirm(false);

  //   const itemDetailsArray =
  //     getItemType === "Item"
  //       ? transferReceiveItemsList?.filter((fil) => fil?.Select)
  //       : transferReceiveKitItemsList
  //         ?.flatMap((kit) => kit?.kitItemList)
  //         ?.filter((fil) => fil?.Select);

  //   const Payload = [
  //     {
  //       // ProcessType: "receive",
  //       ot_details_id: 0,
  //       item_id: 0,
  //       item_kit_id: 0,
  //       indentdetailid: 0,
  //       issuedQuantity: 0,
  //       transitQuantity: 0,
  //       discardedQuantity: 0,
  //       receivedQuantity: itemDetailsArray.reduce(
  //         (sum, i) => sum + Number(i["Receive Qty"] || i.Quantity || 0),
  //         0
  //       ),
  //       receiveStatus: true,
  //       // received_by: currentUserId || 0,
  //       from_store_id: getStore?.value || 0,
  //       to_store_id: selectedToStore?.value || 0,
  //       unit_id: 0,
  //       kitBatchNo: itemDetailsArray[0]?.kitBatchNo || "",
  //       cssdLotNo: itemDetailsArray[0]?.cssdLotNo || "",
  //       // createdBy: currentUserId || "system",
  //       // lastModifiedBy: currentUserId || "system",
  //       createdDate: new Date().toISOString(),
  //       lastModifiedDate: new Date().toISOString(),
  //       details: itemDetailsArray.map((item) => ({
  //         ProcessType: "receive",
  //         id: 0,
  //         ot_details_id: 0,
  //         item_id: item?.itemId || 0,
  //         item_kit_id: item?.kitId ?? 0,
  //         indentdetailid: item?.id ?? 0,
  //         indent_id: item?.indent_id ?? 0,
  //         quantity: Number(item?.qty) || 0,
  //         receiveQty: Number(item?.["Receive Qty"] || item.Quantity || 0),
  //         receiveStatus: true,
  //         // received_by: currentUserId || 0,
  //         receiveDate: new Date().toISOString(),
  //       })),
  //     },
  //   ];

  //   console.log("📤 FINAL TRANSFER OT PAYLOAD:", Payload);

  //   try {
  //     const response = await saveTransferCssdItemsListTransferOT(Payload);

  //     if (response?.status === 200 || response?.status === 201) {
  //       successAlert("Transfer successful!");

  //       // RESET ALL DATA
  //       setTransferReceiveItemsList([]);
  //       setTransferReceiveKitItemsList([]);
  //       setTransferReceiveKitList?.([]);
  //       setKitItemOption?.("kit");
  //       setSearchString?.("");
  //       setGetItemType?.("Kit");

  //       if (typeof fetchCssdKitRequests === "function") {
  //         await fetchCssdKitRequests();
  //       }

  //     } else {
  //       errorAlert("Transfer failed!");
  //     }

  //   } catch (err) {
  //     console.error("❌ API Error:", err);
  //     errorAlert("Something went wrong while transferring.");
  //   }
  // };

  const handleCssdKitClick = async (kit) => {
    setSelectedCssdKit(kit);   // store selected kit object

    try {
      const res = await fetchTransferCssdItemsList(kit.id, kit.kitBatchNo);

      if (res?.data) {
        setCssdReceiveItemList(res.data);   // <-- second table data
      }
    } catch (err) {
      console.error("Failed to load CSSD items", err);
    }
  };

  // const handleCssdItemChange = (kitId, itemIndex, field, value) => {
  //   const updatedKits = receiveCssdKitItemsList.map((kit) => {
  //     if (kit.id === kitId) {
  //       const updatedItems = kit.kitItemList.map((item, idx) => {
  //         if (idx === itemIndex) {
  //           return { ...item, [field]: value };
  //         }
  //         return item;
  //       });
  //       return { ...kit, kitItemList: updatedItems };
  //     }
  //     return kit;
  //   });
  //   setReceiveCssdKitItemsList(updatedKits);
  // };


  const handleCssdItemChange = (kitId, itemIndex, field, value) => {
    const updatedList = receiveCssdKitItemsList.map((kit) => {
      if (kit.id === kitId) {
        const updatedItems = kit.kitItemList.map((item, idx) => {
          if (idx === itemIndex) {
            return { ...item, [field]: value };
          }
          return item;
        });
        return { ...kit, kitItemList: updatedItems };
      }
      return kit;
    });

    setReceiveCssdKitItemsList(updatedList);
  };

  const confirmTransferOT = async () => {
    setShowConfirm(false);

    const itemDetailsArray =
      getItemType === "Item"
        ? transferReceiveItemsList?.filter((fil) => fil?.Select)
        : transferReceiveKitItemsList
          ?.flatMap((kit) => kit?.kitItemList)
          ?.filter((fil) => fil?.Select);

    if (!itemDetailsArray || itemDetailsArray.length === 0) {
      return errorAlert("Please select at least one item.");
    }

    const { id: currentUserId, userName } = user || {};

    // const Payload = [
    //   {
    //     ot_details_id: 0,
    //     item_id: 0,
    //     item_kit_id: 0,
    //     indentdetailid: 0,
    //     issuedQuantity: 0,
    //     transitQuantity: 0,
    //     discardedQuantity: 0,

    //     receivedQuantity: itemDetailsArray.reduce(
    //       (sum, i) => sum + Number(i["Receive Qty"] || i.Quantity || 0),
    //       0
    //     ),

    //     receiveStatus: true,
    //     received_by: currentUserId || 0,

    //     from_store_id: getStore?.value || 0,
    //     to_store_id: selectedToStore?.value || 0,
    //     unit_id: 0,

    //     kitBatchNo: itemDetailsArray?.[0]?.kitBatchNo || "",
    //     cssdLotNo: itemDetailsArray?.[0]?.cssdLotNo || "",

    //     createdBy: currentUserId || "system",
    //     lastModifiedBy: currentUserId || "system",

    //     createdDate: new Date().toISOString(),
    //     lastModifiedDate: new Date().toISOString(),

    //     details: itemDetailsArray.map((item) => ({
    //       ProcessType: "transfer",
    //       id: 0,
    //       ot_details_id: 0,
    //       item_id: item?.itemId || 0,
    //       item_kit_id: item?.kitId ?? 0,
    //       indentdetailid: item?.id ?? 0,
    //       indent_id: item?.indent_id ?? 0,

    //       quantity: Number(item?.qty) || 0,
    //       transferQty: Number(item?.qty) || 0,
    //       receiveQty: Number(item?.["Receive Qty"] || item.Quantity || 0),

    //       receiveStatus: true,
    //       received_by: currentUserId || 0,

    //       receiveDate: new Date().toISOString(),
    //       transferDate: new Date().toISOString(),
    //     })),
    //   },
    // ];


    // const Payload = [
    //   {
    //     ot_details_id: itemDetailsArray?.[0]?.ot_details_id || undefined,
    //     item_id: itemDetailsArray?.[0]?.item_id || undefined,
    //     item_kit_id: itemDetailsArray?.[0]?.item_kit_id || undefined,
    //     indentdetailid: itemDetailsArray?.[0]?.indentdetailid || undefined,
    //     issuedQuantity: itemDetailsArray?.[0]?.issuedQuantity || undefined,
    //     transitQuantity: itemDetailsArray?.[0]?.transitQuantity || undefined,
    //     discardedQuantity: itemDetailsArray?.[0]?.discardedQuantity || undefined,

    //     // Sum of receive quantities
    //     receivedQuantity: itemDetailsArray.reduce(
    //       (sum, i) => sum + (Number(i["Receive Qty"]) || Number(i.Quantity) || 0),
    //       0
    //     ),

    //     receiveStatus: false,
    //     received_by: currentUserId || undefined,

    //     from_store_id: getStore?.value || undefined,
    //     to_store_id: selectedToStore?.value || undefined,
    //     unit_id: itemDetailsArray?.[0]?.unit_id || undefined,

    //     kitBatchNo: itemDetailsArray?.[0]?.kitBatchNo || "",
    //     cssdLotNo: itemDetailsArray?.[0]?.cssdLotNo || "",

    //     createdBy: currentUserId || "system",
    //     lastModifiedBy: currentUserId || "system",

    //     createdDate: new Date().toISOString(),
    //     lastModifiedDate: new Date().toISOString(),

    //     details: itemDetailsArray.map((item) => ({
    //       ProcessType: "transfer",
    //       id: item?.id || undefined,
    //       ot_details_id: item?.ot_details_id || undefined,
    //       item_id: item?.itemId || undefined,
    //       item_kit_id: item?.kitId || undefined,
    //       indentdetailid: item?.id || undefined,
    //       indent_id: item?.indent_id || undefined,

    //       quantity: Number(item?.qty) || undefined,
    //       transferQty: Number(item?.qty) || undefined,
    //       receiveQty: Number(item?.["Receive Qty"] || item.Quantity) || undefined,

    //       receiveStatus: true,
    //       received_by: currentUserId || undefined,

    //       receiveDate: item?.receiveDate || new Date().toISOString(),
    //       transferDate: item?.transferDate || new Date().toISOString(),
    //     })),
    //   },
    // ];


    // const Payload = [
    //   {
    //     ...(() => {
    //       const base = {
    //         receivedQuantity: itemDetailsArray.reduce(
    //           (sum, i) => sum + Number(i["Receive Qty"] || i.Quantity || 0),
    //           0
    //         ),
    //         receiveStatus: true,
    //         received_by: currentUserId || 0,
    //         from_store_id: getStore?.value || 0,
    //         to_store_id: selectedToStore?.value || 0,
    //         kitBatchNo: itemDetailsArray?.[0]?.kitBatchNo || "",
    //         cssdLotNo: itemDetailsArray?.[0]?.cssdLotNo || "",
    //         createdBy: currentUserId || "system",
    //         lastModifiedBy: currentUserId || "system",
    //         createdDate: new Date().toISOString(),
    //         lastModifiedDate: new Date().toISOString(),
    //       };

    //       // Remove keys with 0 or empty string values
    //       return Object.fromEntries(
    //         Object.entries(base).filter(([_, value]) => value !== 0 && value !== "")
    //       );
    //     })(),

    //     details: itemDetailsArray.map((item) => {
    //       const detail = {
    //         ProcessType: "transfer",
    //         item_id: item?.itemId,
    //         item_kit_id: item?.kitId,
    //         indentdetailid: item?.id,
    //         indent_id: item?.indent_id,
    //         quantity: Number(item?.qty) || 0,
    //         transferQty: Number(item?.qty) || 0,
    //         receiveQty: Number(item?.["Receive Qty"] || item.Quantity || 0),
    //         receiveStatus: false,
    //         received_by: currentUserId || 0,
    //         receiveDate: null,
    //         transferDate: new Date().toISOString(),
    //         transferStatus: true,
    //       };

    //       // Remove keys with 0 or undefined values
    //       return Object.fromEntries(
    //         Object.entries(detail).filter(([_, value]) => value !== 0 && value !== undefined)
    //       );
    //     }),
    //   },
    // ];

    // const Payload = [
    //   {
    //     ot_details_id: 0,
    //     item_id: 0,
    //     item_kit_id: 0,
    //     indentdetailid: 0,
    //     issuedQuantity: 0,
    //     transitQuantity: 0,
    //     discardedQuantity: 0,

    //     // receivedQuantity: apiResult.reduce((sum, i) => sum + Number(i.Quantity || 0), 0),
    //     receivedQuantity: itemDetailsArray.reduce(
    //       (sum, i) => sum + Number(i["Receive Qty"] || i.Quantity || 0),
    //       0
    //     ),


    //     receiveStatus: true,
    //     received_by: currentUserId,

    //     from_store_id: getStore?.value || 0,
    //     to_store_id: selectedToStore?.value || 0,
    //     unit_id: 0,

    //     kitBatchNo: "", // set if you have batch info
    //     cssdLotNo: "",  // set if you have lot info

    //     createdBy: currentUserId,
    //     lastModifiedBy: currentUserId,

    //     createdDate: new Date().toISOString(),
    //     lastModifiedDate: new Date().toISOString(),

    //     details: itemDetailsArray.map((item) => ({
    //       ProcessType: "transfer",
    //       id: 0,
    //       ot_details_id: 0,
    //       item_id: item.ItemId,
    //       item_kit_id: item.KitFormationId,
    //       indentdetailid: item.id,
    //       indent_id: 0, // set if available

    //       quantity: Number(item.Quantity || 0),
    //       transferQty: Number(item.Quantity || 0),
    //       receiveQty: Number(item.Quantity || 0),

    //       receiveStatus: true,
    //       received_by: currentUserId,

    //       receiveDate: new Date().toISOString(),
    //       transferDate: new Date().toISOString(),
    //     })),
    //   },
    // ];

    const Payload = [
      {
        ot_details_id: 0,
        item_id: 0,
        item_kit_id: 0,
        indentdetailid: 0,
        issuedQuantity: 0,
        transitQuantity: 0,
        discardedQuantity: 0,

        receivedQuantity: itemDetailsArray.reduce(
          (sum, i) => sum + Number(i["Receive Qty"] || i.Quantity || 0),
          0
        ),

        receiveStatus: true,
        received_by: currentUserId,

        from_store_id: getStore?.value || 1,
        to_store_id: selectedToStore?.value || 2,
        unit_id: 0,

        // Set kitBatchNo from first item (or from the kit if consistent)
        kitBatchNo: itemDetailsArray[0]?.batchCode || "",
        cssdLotNo: "",

        createdBy: currentUserId,
        lastModifiedBy: currentUserId,
        createdDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),

        // details: itemDetailsArray.map((item) => ({
        //   ProcessType: "transfer",
        //   id: 0,
        //   ot_details_id: 0,
        //   item_id: item.item_id,
        //   // item_kit_id: item.kitId,
        //   item_kit_id: item.item_kit_id ?? item.kitId ?? 0,
        //   indentdetailid: item.id,
        //   indent_id: 0,

        //   // quantity: Number(item.qty || 0),
        //   quantity: Number(item["Quantity"] || item.qty || 0),
        //   transferQty: Number(item.qty || 0),
        //   receiveQty: Number(item.qty || 0),

        //   // Add batchCode for each item
        //   kitBatchNo: item.kitBatchNo || "",

        //   receiveStatus: true,
        //   received_by: currentUserId,

        //   receiveDate: new Date().toISOString(),
        //   transferDate: new Date().toISOString(),
        // })),

        details: itemDetailsArray.map((item) => ({
          ProcessType: "transfer",
          id: 0,
          ot_details_id: 0,

          item_id: Number(item.item_id),           // item id
          item_kit_id: Number(item.kitId),   // ALWAYS kitId, never 0

          indentdetailid: item.id,
          indent_id: 0,

          quantity: Number(item["Quantity"] || item.qty || 0),
          transferQty: Number(item.Quantity || 0),
          receiveQty: Number(item.qty || 0),

          kitBatchNo: item.kitBatchNo || "",
          KitName: item.KitName || "",

          receiveStatus: true,
          received_by: currentUserId,

          receiveDate: new Date().toISOString(),
          transferDate: new Date().toISOString(),
        }))

      },
    ];

    // const Payload = [
    //   {
    //     ot_details_id: 0,
    //     item_id: 0,
    //     item_kit_id: 0,
    //     indentdetailid: 0,
    //     issuedQuantity: 0,
    //     transitQuantity: 0,
    //     discardedQuantity: 0,

    //     // Total received quantity
    //     receivedQuantity: itemDetailsArray.reduce(
    //       (sum, i) => sum + Number(i.Quantity || 0),
    //       0
    //     ),

    //     receiveStatus: true,
    //     received_by: currentUserId,

    //     from_store_id: getStore?.value || 0,
    //     to_store_id: selectedToStore?.value || 0,
    //     unit_id: 0,

    //     // Take batchCode from first item if available
    //     kitBatchNo: itemDetailsArray[0]?.batchCode || "",
    //     cssdLotNo: "",

    //     createdBy: currentUserId,
    //     lastModifiedBy: currentUserId,
    //     createdDate: new Date().toISOString(),
    //     lastModifiedDate: new Date().toISOString(),

    //     details: itemDetailsArray.map((item) => ({
    //       ProcessType: "transfer",
    //       id: 0,
    //       ot_details_id: 0,
    //       item_id: item.ItemId,
    //       // item_kit_id: item.KitFormationId, // ✅ THIS IS YOUR kitId
    //       // kitId: item.KitFormationId,
    //       item_kit_id: item.kitId,      // <-- direct from API
    //       KitName: item.KitName,
    //       indentdetailid: item.id,
    //       indent_id: 0,

    //       quantity: Number(item.Quantity || 0),
    //       transferQty: Number(item.Quantity || 0),
    //       receiveQty: Number(item.Quantity || 0),

    //       kitBatchNo: item.batchCode || "",

    //       receiveStatus: true,
    //       received_by: currentUserId,

    //       receiveDate: new Date().toISOString(),
    //       transferDate: new Date().toISOString(),
    //     })),
    //   },
    // ];

    console.log("📤 FINAL TRANSFER OT PAYLOAD:", Payload);

    let isSuccess = false;

    try {
      const response = await saveTransferCssdItemsListTransferOT(Payload);

      if (response?.status === 200 || response?.status === 201) {
        isSuccess = true;
        successAlert("Transfer successful!");

        // RESET DATA
        setTransferReceiveItemsList([]);
        setTransferReceiveKitItemsList([]);
        setTransferReceiveKitList?.([]);
        setKitItemOption?.("kit");
        setSearchString?.("");
        setGetItemType?.("Kit");

        if (typeof fetchCssdKitRequests === "function") {
          await fetchCssdKitRequests();
        }
      } else {
        errorAlert("Transfer failed!");
      }

    } catch (err) {
      console.error("❌ API Error:", err);

      // ❗ Only show error alert if success hasn't already fired
      if (!isSuccess) {
        errorAlert("Something went wrong while transferring.");
      }
    }

  };


  const handleSubmit = async () => {
    const itemDetailsArray =
      getItemType === "Item"
        ? transferReceiveItemsList?.filter((fil) => fil?.Select)
        : transferReceiveKitItemsList
          ?.flatMap((kit) => kit?.kitItemList)
          ?.filter((fil) => fil?.Select);

    if (!itemDetailsArray?.length) {
      warningAlert("Please select at least one item!");
      return;
    }

    setShowConfirm(true);
  };

  const confirmSubmit = async () => {
    setShowConfirm(false);

    const itemDetailsArray =
      getItemType === "Item"
        ? transferReceiveItemsList?.filter(fil => fil?.Select)
        : transferReceiveKitItemsList
          ?.flatMap(kit => kit?.kitItemList)
          ?.filter(fil => fil?.Select);

    const payload = {
      indentFormStoreId: getStore?.value || 0,
      indentDetails: itemDetailsArray.map(item => ({
        kitid: item?.kitId ?? item?.kitid ?? 0,
        itemId: item?.ItemId || item?.id || 0,
        qty: Number(item?.Quantity) || 0,
        // issuedQty: Number(item?.IssueQty) || 0,

      })),
    };

    try {
      const response = await saveCssdIndentDetails(payload);
      console.log("✅ API Response:", response);

      if (response?.status === 200 || response?.status === 201) {
        successAlert("Kit Request saved successfully!");

        try {
          setTransferReceiveItemsList([]);
          setTransferReceiveKitItemsList([]);
          setTransferReceiveKitList?.([]);
          setKitItemOption?.("kit");
          setSearchString?.("");
          setGetItemType?.("Kit");

          if (typeof fetchCssdKitRequests === "function") {
            await fetchCssdKitRequests();
          } else {
            console.warn("⚠️ fetchCssdKitRequests not defined.");
          }

        } catch (refreshErr) {
          console.error("⚠️ Error refreshing data:", refreshErr);
        }
      } else {
        errorAlert("Failed to save Kit Request.");
      }
    } catch (err) {
      console.error("❌ API Error:", err);
      errorAlert("Something went wrong while saving Kit Request.");
    }
  };

  // 1️⃣ Open confirm dialog first
  const handleReceive = async () => {
    const itemDetailsArray =
      getItemType === "Kit"
        ? transferReceiveKitList?.filter((fil) => fil?.Select)
        : receiveKitItemsList
          ?.flatMap((kit) => kit?.kitItemList)
          ?.filter((fil) => fil?.Select);

    if (!itemDetailsArray?.length) {
      warningAlert("Please select at least one item to receive!");
      return;
    }

    setShowConfirm(true); // open confirm popup
  };



  // // 2️⃣ Confirm Receive and send API request
  // const confirmReceive = async () => {
  //   setShowConfirm(false);

  //   const itemDetailsArray =
  //     getItemType === "Kit"
  //       ? transferReceiveKitList?.filter((fil) => fil?.Select)
  //       : receiveKitItemsList
  //         ?.flatMap((kit) => kit?.kitItemList)
  //         ?.filter((fil) => fil?.Select);

  //   const { id: currentUserId } = user || {};

  //   // const Payload = [
  //   //   {
  //   //     // ProcessType: "receive",
  //   //     ot_details_id: 0,
  //   //     item_id: 0,
  //   //     item_kit_id: 0,
  //   //     indentdetailid: 0,
  //   //     issuedQuantity: 0,
  //   //     transitQuantity: 0,
  //   //     discardedQuantity: 0,
  //   //     receivedQuantity: itemDetailsArray.reduce(
  //   //       (sum, i) => sum + Number(i["Receive Qty"] || i.Quantity || 0),
  //   //       0
  //   //     ),
  //   //     receiveStatus: true,
  //   //     received_by: currentUserId || 0,
  //   //     from_store_id: getStore?.value || 0,
  //   //     to_store_id: selectedToStore?.value || 0,
  //   //     unit_id: 0,
  //   //     kitBatchNo: itemDetailsArray[0]?.kitBatchNo || "",
  //   //     cssdLotNo: itemDetailsArray[0]?.cssdLotNo || "",
  //   //     createdBy: currentUserId || "system",
  //   //     lastModifiedBy: currentUserId || "system",
  //   //     createdDate: new Date().toISOString(),
  //   //     lastModifiedDate: new Date().toISOString(),
  //   //     details: itemDetailsArray.map((item) => ({
  //   //       ProcessType: "receive",
  //   //       id: 0,
  //   //       ot_details_id: 0,
  //   //       item_id: item?.itemId || 0,
  //   //       item_kit_id: item?.kitId ?? 0,
  //   //       indentdetailid: item?.id ?? 0,
  //   //       indent_id: item?.indent_id ?? 0,
  //   //       quantity: Number(item?.qty) || 0,
  //   //       receiveQty: Number(item?.["Receive Qty"] || item.Quantity || 0),
  //   //       receiveStatus: true,
  //   //       received_by: currentUserId || 0,
  //   //       receiveDate: new Date().toISOString(),
  //   //     })),
  //   //   },
  //   // ];
  //   // const Payload = (getItemType === "Item"
  //   //   ? transferReceiveKitList
  //   //   : receiveKitItemsList
  //   //     ?.flatMap(kit => kit?.kitItemList)
  //   // )?.filter(item => item?.Select) // only selected rows
  //   //   .map(item => ({
  //   //     id: item?.id || 0,
  //   //     ot_details_id: 0,
  //   //     item_id: item?.itemId || 0,
  //   //     // item_id: item && item.itemId ? item.itemId : 0,
  //   //     // item_id: item?.itemId ?? 0,
  //   //     item_kit_id: item?.kitId || 0,
  //   //     processType: "receive",
  //   //     // quantity: Number(item?.qty) || 0,
  //   //     quantity: item?.qty || 0,
  //   //     transferDate: new Date().toISOString(),
  //   //     transferQty: 0,
  //   //     transferStatus: true,
  //   //     transferred_by: currentUserId || 0,
  //   //     issueDate: new Date().toISOString(),
  //   //     issueStatus: true,
  //   //     issueQty: 0,
  //   //     issued_by: currentUserId || 0,
  //   //     disposedDate: new Date().toISOString(),
  //   //     disposedQty: 0,
  //   //     disposed_by: 0,
  //   //     disposedReason: "",
  //   //     receiveDate: new Date().toISOString(),
  //   //     receiveQty: Number(item?.["Receive Qty"] || item.Quantity || 0),
  //   //     receiveStatus: true,
  //   //     received_by: currentUserId || 0,
  //   //     cleaningStatus: true,
  //   //     decontaminationStatus: true,
  //   //     cleanedQty: 0,
  //   //     cleaned_by: 0,
  //   //     cleaningStartDate: new Date().toISOString(),
  //   //     cleaningEndDate: new Date().toISOString(),
  //   //     wrappedQty: 0,
  //   //     wrappingStatus: true,
  //   //     wrapped_by: 0,
  //   //     wrapper_type_id: 0,
  //   //     wrapperTypeQty: 0,
  //   //     wrapping_method_id: 0,
  //   //     wrappingStartDate: new Date().toISOString(),
  //   //     wrappingEndDate: new Date().toISOString(),
  //   //     sterilizationQty: 0,
  //   //     sterilizationStatus: true,
  //   //     sterilizationStatusType: "",
  //   //     sterilization_start_by: 0,
  //   //     sterilizationStartDate: new Date().toISOString(),
  //   //     sterilizationEndDate: new Date().toISOString(),
  //   //     sterilization_end_by: 0,
  //   //     machine_id: 0,
  //   //     sterilization_type_id: 0,
  //   //     sterilization_method: 0,
  //   //     sterilizationExpiryDate: new Date().toISOString(),
  //   //     addToStockQty: 0,
  //   //     temperature: 0,
  //   //     pressure: 0,
  //   //     durationMinutes: 0,
  //   //     indicatorResult: "",
  //   //     from_store_id: getStore?.value || 0,
  //   //     to_store_id: selectedToStore?.value || 0,
  //   //     itemBatchNo: item?.itemBatchNo || "",
  //   //     kitBatchNo: item?.kitBatchNo || "",
  //   //     cssdLotNo: item?.cssdLotNo || "",
  //   //     createdBy: currentUserId || "system",
  //   //     lastModifiedBy: currentUserId || "system",
  //   //     createdDate: new Date().toISOString(),
  //   //     lastModifiedDate: new Date().toISOString(),
  //   //   }));



  // 2️⃣ Confirm Receive and send API request



  const confirmReceive = async () => {
    setShowConfirm(false);

    const itemDetailsArray =
      getItemType === "Item"
        ? transferReceiveKitList?.filter((fil) => fil?.Select)
        : receiveKitItemsList
          ?.flatMap((kit) => kit?.kitItemList)
          ?.filter((fil) => fil?.Select);

    const { id: currentUserId } = user || {};

    // ⚠️ If nothing selected
    if (!itemDetailsArray.length) {
      errorAlert("Please select at least one item before adding to stock.");
      setOpenBackdrop(false);
      return;
    }

    // ✅ Build simplified payload
    const payload = itemDetailsArray.map(item => ({
      // itemId: item.itemId ?? 0,
      id: item?.id || 0,
      processType: "addreceivestock",
      itemId: item.ItemCode ?? item.itemCode ?? 0,
      storeId: 2, // assuming you want current store
      kitId: item.kitId ?? 0,
      qty: Number(item.Quantity ?? 0),
      batchCode: item.BatchNo ?? "string"
    }));

    try {
      // 🔹 Call your API
      const response = await saveTransferCssdItemsListStock(payload);
      console.log("✅ Receive API Response:", response);

      if (response?.status === 200 || response?.status === 201) {
        successAlert("Items received successfully!");

        // Reset UI and refresh data
        try {
          setTransferReceiveItemsList([]);
          setTransferReceiveKitItemsList([]);
          setTransferReceiveKitList?.([]);
          setTransferCSSDList([]);
          setReceiveKitItemsList([]);
          setKitItemOption?.("kit");
          setSearchString?.("");
          setGetItemType?.("Kit");

          if (typeof fetchCssdKitRequests === "function") {
            await fetchCssdKitRequests();
          } else {
            console.warn("⚠️ fetchCssdKitRequests not defined.");
          }
        } catch (refreshErr) {
          console.error("⚠️ Error refreshing data:", refreshErr);
        }
      } else {
        errorAlert("Failed to receive CSSD items.");
      }
    } catch (err) {
      console.error("❌ API Error:", err);
      errorAlert("Something went wrong while receiving CSSD items.");
    }
  };

  // const handleReceiveCSSD = async () => {
  //   // Flatten all kits and filter selected items
  //   const selectedItems = receiveCssdKitItemsList
  //     ?.flatMap((kit) => kit.kitItemList ?? [])
  //     ?.filter((item) => item.Select);

  //   if (!selectedItems?.length) {
  //     warningAlert("Please select at least one item to receive!");
  //     return;
  //   }

  //   setShowConfirm(true); // open confirm popup
  // };


  // const confirmReceiveCSSD = async () => {
  //   setShowConfirm(false);

  //   // ✅ FIX: Define selectedItems here
  //   const selectedItems =
  //     getItemType === "Item"
  //       ? transferReceiveItemsList?.filter((item) => item?.Select)
  //       : transferReceiveKitItemsList
  //         ?.flatMap((kit) => kit?.kitItemList)
  //         ?.filter((item) => item?.Select);

  //   if (!selectedItems || selectedItems.length === 0) {
  //     warningAlert("Please select at least one item!");
  //     return;
  //   }

  //   const Payload = {
  //     indentFormStoreId: getStore?.value || 0,
  //     indentDetails: selectedItems.map((item) => ({
  //       kitid: item?.kitId || item?.kitid || 0,
  //       itemId: item?.ItemId || item?.id || 0,
  //       qty: Number(item?.Quantity) || 0,
  //     })),
  //   };

  //   try {
  //     const response = await saveTransferCssdItemsList(Payload);

  //     if (response?.status === 200 || response?.status === 201) {
  //       successAlert("CSSD Items Received Successfully!");

  //       // RESET ALL
  //       setTransferReceiveItemsList([]);
  //       setTransferReceiveKitItemsList([]);
  //       setTransferReceiveKitList?.([]);
  //       setKitItemOption?.("kit");
  //       setSearchString?.("");
  //       setGetItemType?.("Kit");

  //       if (typeof fetchCssdKitRequests === "function") {
  //         await fetchCssdKitRequests();
  //       }
  //     } else {
  //       errorAlert("Receive CSSD failed!");
  //     }
  //   } catch (err) {
  //     console.error("❌ API Error:", err);
  //     errorAlert("Something went wrong while receiving CSSD items.");
  //   }
  // };


  // 1️⃣ Handle Receive button click
  // const handleReceiveCSSD = async () => {
  //   // Flatten all kits and filter selected items
  //   const selectedItems = receiveKitItemsList
  //     ?.flatMap((kit) => kit.kitItemList ?? [])
  //     ?.filter((item) => item.Select);

  //   if (!selectedItems?.length) {
  //     warningAlert("Please select at least one item to receive!");
  //     return;
  //   }

  //   // Open confirm dialog
  //   setShowConfirm(true);
  // };

  // const handleReceiveCSSD = async () => {
  //   // 1️⃣ Flatten all kits and filter selected items
  //   const selectedItems = receiveKitItemsList
  //     ?.flatMap((kit) => kit.kitItemList ?? [])
  //     ?.filter((item) => item.Select);

  //   // 2️⃣ Check if any item is selected
  //   if (!selectedItems?.length) {
  //     warningAlert("Please select at least one item to receive!");
  //     return;
  //   }

  //   // 3️⃣ Prepare payload for API
  //   // const Payload = {
  //   //   indentFormStoreId: getStore?.value || 0,
  //   //   indentDetails: selectedItems.map((item) => ({
  //   //     kitid: item?.kitId || item?.kitid || 0,
  //   //     itemId: item?.ItemId || item?.id || 0,
  //   //     qty: Number(item?.Quantity || 0),
  //   //   })),
  //   // };

  //   // 3️⃣ Prepare payload for API
  //   const Payload = selectedItems.map((item) => ({
  //     id: item?.id || 0,
  //     ot_details_id: item?.ot_details_id || 0,
  //     item_id: item?.ItemId || item?.id || 0,
  //     item_kit_id: item?.kitId || item?.kitid || 0,
  //     processType: item?.processType || "string",
  //     quantity: Number(item?.Quantity || 0),
  //     transferDate: item?.transferDate || new Date().toISOString(),
  //     transferQty: Number(item?.transferQty || 0),
  //     transferStatus: item?.transferStatus ?? true,
  //     transferred_by: item?.transferred_by || 0,
  //     issueDate: item?.issueDate || new Date().toISOString(),
  //     issueStatus: item?.issueStatus ?? true,
  //     issueQty: Number(item?.issueQty || 0),
  //     issued_by: item?.issued_by || 0,
  //     disposedDate: item?.disposedDate || new Date().toISOString(),
  //     disposedQty: Number(item?.disposedQty || 0),
  //     disposed_by: item?.disposed_by || 0,
  //     disposedReason: item?.disposedReason || "string",
  //     receiveDate: item?.receiveDate || new Date().toISOString(),
  //     receiveQty: Number(item?.receiveQty || 0),
  //     receiveStatus: item?.receiveStatus ?? true,
  //     received_by: item?.received_by || 0,
  //     cleaningStatus: item?.cleaningStatus ?? true,
  //     decontaminationStatus: item?.decontaminationStatus ?? true,
  //     cleanedQty: Number(item?.cleanedQty || 0),
  //     cleaned_by: item?.cleaned_by || 0,
  //     cleaningStartDate: item?.cleaningStartDate || new Date().toISOString(),
  //     cleaningEndDate: item?.cleaningEndDate || new Date().toISOString(),
  //     wrappedQty: Number(item?.wrappedQty || 0),
  //     wrappingStatus: item?.wrappingStatus ?? true,
  //     wrapped_by: item?.wrapped_by || 0,
  //     wrapper_type_id: item?.wrapper_type_id || 0,
  //     wrapperTypeQty: Number(item?.wrapperTypeQty || 0),
  //     wrapping_method_id: item?.wrapping_method_id || 0,
  //     wrappingStartDate: item?.wrappingStartDate || new Date().toISOString(),
  //     wrappingEndDate: item?.wrappingEndDate || new Date().toISOString(),
  //     sterilizationQty: Number(item?.sterilizationQty || 0),
  //     sterilizationStatus: item?.sterilizationStatus ?? true,
  //     sterilizationStatusType: item?.sterilizationStatusType || "string",
  //     sterilization_start_by: item?.sterilization_start_by || 0,
  //     sterilizationStartDate: item?.sterilizationStartDate || new Date().toISOString(),
  //     sterilizationEndDate: item?.sterilizationEndDate || new Date().toISOString(),
  //     sterilization_end_by: item?.sterilization_end_by || 0,
  //     machine_id: item?.machine_id || 0,
  //     sterilization_type_id: item?.sterilization_type_id || 0,
  //     sterilization_method: item?.sterilization_method || 0,
  //     sterilizationExpiryDate: item?.sterilizationExpiryDate || new Date().toISOString(),
  //     addToStockQty: Number(item?.addToStockQty || 0),
  //     temperature: Number(item?.temperature || 0),
  //     pressure: Number(item?.pressure || 0),
  //     durationMinutes: Number(item?.durationMinutes || 0),
  //     indicatorResult: item?.indicatorResult || "string",
  //     from_store_id: item?.from_store_id || 0,
  //     to_store_id: item?.to_store_id || 0,
  //     itemBatchNo: item?.itemBatchNo || "string",
  //     kitBatchNo: item?.kitBatchNo || "string",
  //     cssdLotNo: item?.cssdLotNo || "string",
  //     createdBy: item?.createdBy || "string",
  //     lastModifiedBy: item?.lastModifiedBy || "string",
  //     createdDate: item?.createdDate || new Date().toISOString(),
  //     lastModifiedDate: item?.lastModifiedDate || new Date().toISOString()
  //   }));



  //   // 4️⃣ Call API to save
  //   try {
  //     const response = await saveTransferCssdItemsList(Payload);

  //     if (response?.status === 200 || response?.status === 201) {
  //       successAlert("CSSD Items Received Successfully!");

  //       // 5️⃣ Reset all relevant states
  //       setReceiveKitItemsList([]);
  //       setTransferReceiveKitItemsList([]);
  //       setTransferReceiveKitList([]);
  //       setKitItemOption("kit");
  //       setSearchString("");
  //       setGetItemType("Kit");
  //       setReceiveCssdList([]);

  //       // 6️⃣ Refresh table
  //       if (typeof fetchCssdKitRequests === "function") {
  //         await fetchCssdKitRequests();
  //       }
  //     } else {
  //       errorAlert("Receive CSSD failed!");
  //     }
  //   } catch (err) {
  //     console.error("❌ API Error:", err);
  //     errorAlert("Something went wrong while receiving CSSD items.");
  //   }
  // };


  const handleReceiveCSSD = async () => {
    try {
      // 1️⃣ Flatten all kits and filter selected items
      const selectedItems = receiveKitItemsList
        ?.flatMap((kit) => kit.kitItemList ?? [])
        ?.filter((item) => item.Select);

      // 2️⃣ Check if any item is selected
      if (!selectedItems?.length) {
        warningAlert("Please select at least one item to receive!");
        return;
      }

      // 3️⃣ Prepare payload for API
      const Payload = selectedItems.map((item) => ({

        id: item?.id || 0,
        ot_details_id: item?.ot_details_id || 0,
        item_id: item?.ItemCode || item?.id || 0,
        // item_id: Number(item.item_id),           // item id
        item_kit_id: item?.kitId || item?.kitid || 0,
        kitBatchNo: item?.BatchNo?.trim() || "string",
        kitBatchNo: item?.BatchNo || "string",
        processType: "receive",
        from_store_id: getStore?.value || 2,
        to_store_id: selectedToStore?.value || 1,
        // quantity: Number(item?.Quantity || 0),
        quantity: Number(item["Quantity"] || item.qty || 0),
        transferDate: item?.transferDate || new Date().toISOString(),
        transferQty: Number(item?.transferQty || 0),
        transferStatus: item?.transferStatus ?? true,
        transferred_by: item?.transferred_by || 0,
        issueDate: item?.issueDate || new Date().toISOString(),
        issueStatus: item?.issueStatus ?? true,
        issueQty: Number(item?.issueQty || 0),
        issued_by: item?.issued_by || 0,
        disposedDate: item?.disposedDate || new Date().toISOString(),
        disposedQty: Number(item?.disposedQty || 0),
        disposed_by: item?.disposed_by || 0,
        disposedReason: item?.disposedReason || "string",
        receiveDate: item?.receiveDate || new Date().toISOString(),
        // receiveQty: Number(item?.receiveQty || 0),
        receiveQty: Number(item.qty || 0),
        receiveStatus: item?.receiveStatus ?? true,
        received_by: item?.received_by || 0,
        cleaningStatus: item?.cleaningStatus ?? true,
        decontaminationStatus: item?.decontaminationStatus ?? true,
        cleanedQty: Number(item?.cleanedQty || 0),
        cleaned_by: item?.cleaned_by || 0,
        cleaningStartDate: item?.cleaningStartDate || new Date().toISOString(),
        cleaningEndDate: item?.cleaningEndDate || new Date().toISOString(),
        wrappedQty: Number(item?.wrappedQty || 0),
        wrappingStatus: item?.wrappingStatus ?? true,
        wrapped_by: item?.wrapped_by || 0,
        wrapper_type_id: item?.wrapper_type_id || 0,
        wrapperTypeQty: Number(item?.wrapperTypeQty || 0),
        wrapping_method_id: item?.wrapping_method_id || 0,
        wrappingStartDate: item?.wrappingStartDate || new Date().toISOString(),
        wrappingEndDate: item?.wrappingEndDate || new Date().toISOString(),
        sterilizationQty: Number(item?.sterilizationQty || 0),
        sterilizationStatus: item?.sterilizationStatus ?? true,
        sterilizationStatusType: item?.sterilizationStatusType || "string",
        sterilization_start_by: item?.sterilization_start_by || 0,
        sterilizationStartDate: item?.sterilizationStartDate || new Date().toISOString(),
        sterilizationEndDate: item?.sterilizationEndDate || new Date().toISOString(),
        sterilization_end_by: item?.sterilization_end_by || 0,
        machine_id: item?.machine_id || 0,
        sterilization_type_id: item?.sterilization_type_id || 0,
        sterilization_method: item?.sterilization_method || 0,
        sterilizationExpiryDate: item?.sterilizationExpiryDate || new Date().toISOString(),
        addToStockQty: Number(item?.addToStockQty || 0),
        temperature: Number(item?.temperature || 0),
        pressure: Number(item?.pressure || 0),
        durationMinutes: Number(item?.durationMinutes || 0),
        indicatorResult: item?.indicatorResult || "string",
        from_store_id: item?.from_store_id || 0,
        to_store_id: item?.to_store_id || 1,
        itemBatchNo: item?.itemBatchNo || "string",
        // kitBatchNo: item?.BatchNo || "string",
        cssdLotNo: item?.cssdLotNo || "string",
        createdBy: item?.createdBy || "string",
        lastModifiedBy: item?.lastModifiedBy || "string",
        createdDate: item?.createdDate || new Date().toISOString(),
        lastModifiedDate: item?.lastModifiedDate || new Date().toISOString()
      }));

      // 4️⃣ Debug: log payload before sending
      console.log("CSSD Receive Payload:", JSON.stringify(Payload, null, 2));

      // 5️⃣ Call API to save
      const response = await saveTransferCssdItemsList(Payload);

      if (response?.status === 200 || response?.status === 201) {
        successAlert("CSSD Items Received Successfully!");


        // 6️⃣ Reset all relevant states
        setReceiveKitItemsList([]);
        setTransferReceiveKitItemsList([]);
        setTransferReceiveKitList([]);
        setReceiveCssdList([]);

        setKitItemOption("kit");
        setSearchString("");
        setGetItemType("Kit");

        // 7️⃣ Refresh table
        if (typeof fetchCssdKitRequests === "function") {
          await fetchCssdKitRequests();
        }
      } else {
        // Show backend error message if available
        const message = response?.data?.message || `Receive CSSD failed! Status: ${response?.status}`;
        // errorAlert(message);
      }
    } catch (err) {
      console.error("❌ API Error:", err.response || err);
      // Only show backend error if available, no generic "something went wrong"
      const apiMessage = err?.response?.data?.message || err?.message || "Receive CSSD failed!";
      // errorAlert(apiMessage);
    }
  };


  // 2️⃣ Confirm Receive action
  // const confirmReceiveCSSD = async () => {
  //   setShowConfirm(false);

  //   // ✅ Use the same source state as handleReceiveCSSD
  //   const selectedItems = receiveCssdKitItemsList
  //     ?.flatMap((kit) => kit.kitItemList ?? [])
  //     ?.filter((item) => item.Select);

  //   if (!selectedItems?.length) {
  //     warningAlert("Please select at least one item to receive!");
  //     return;
  //   }

  //   // Build payload
  //   const payload = {
  //     indentFormStoreId: getStore?.value || 0,
  //     indentDetails: selectedItems.map((item) => ({
  //       kitid: item?.kitId || item?.kitid || 0,
  //       itemId: item?.itemId || item?.id || 0,
  //       qty: Number(item?.ReceiveQty || item?.Quantity || 0),
  //     })),
  //   };

  //   try {
  //     const response = await saveTransferCssdItemsList(payload);

  //     if (response?.status === 200 || response?.status === 201) {
  //       successAlert("CSSD Items Received Successfully!");

  //       // RESET ALL
  //       setReceiveCssdKitItemsList([]); // clear kit state
  //       setCssdTab(null);
  //       setGetItemType("Kit");
  //       setSearchString("");

  //       // Refresh kit requests
  //       if (typeof fetchCssdKitRequests === "function") {
  //         await fetchCssdKitRequests();
  //       }
  //     } else {
  //       errorAlert("Receive CSSD failed!");
  //     }
  //   } catch (err) {
  //     console.error("❌ API Error:", err);
  //     errorAlert("Something went wrong while receiving CSSD items.");
  //   }
  // };

  const confirmReceiveCSSD = async () => {
    setShowConfirm(false); // close popup

    const selectedItems = receiveCssdKitItemsList
      ?.flatMap((kit) => kit.kitItemList ?? [])
      ?.filter((item) => item.Select);

    if (!selectedItems?.length) {
      warningAlert("Please select at least one item!");
      return;
    }

    const payload = {
      indentFormStoreId: getStore?.value || 0,
      indentDetails: selectedItems.map((item) => ({
        kitid: item?.kitId || item?.kitid || 0,
        itemId: item?.itemId || item?.id || 0,
        qty: Number(item?.ReceiveQty || item?.Quantity || 0),
      })),
    };

    try {
      const response = await saveTransferCssdItemsList(payload);

      if (response?.status === 200 || response?.status === 201) {
        successAlert("CSSD Items Received Successfully!");
        // RESET state
        setReceiveCssdKitItemsList([]);
        setCssdTab(null);
        setGetItemType("Kit");
        setSearchString("");
        fetchCssdKitRequests?.();
      } else {
        errorAlert("Receive CSSD failed!");
      }
    } catch (err) {
      console.error("❌ API Error:", err);
      errorAlert("Something went wrong while receiving CSSD items.");
    }
  };

  const handleTransfer = async () => {
    const itemDetailsArray =
      getItemType === "Kit"
        ? transferReceiveItemsList?.filter((fil) => fil?.Select)
        : transferReceiveKitItemsList
          ?.flatMap((kit) => kit?.kitItemList)
          ?.filter((fil) => fil?.Select);

    if (!itemDetailsArray?.length) {
      warningAlert("Please select at least one item to transfer!");
      return;
    }

    setShowConfirm(true);
  };


  const confirmTransfer = async () => {
    setShowConfirm(false);

    const itemDetailsArray =
      getItemType === "Kit"
        ? transferReceiveItemsList?.filter((fil) => fil?.Select)
        : transferReceiveKitItemsList
          ?.flatMap((kit) => kit?.kitItemList)
          ?.filter((fil) => fil?.Select);

    const { id: currentUserId } = user || {};


    if (!itemDetailsArray?.length) {
      warningAlert("Please select at least one item to transfer!");
      return;
    }

    // const transferPayload = [
    //   {
    //     issueFormStoreId: getStore?.value || 0,
    //     indentId: itemDetailsArray?.[0]?.indentid ?? itemDetailsArray?.[0]?.indent_id ?? 0,
    //     issueDetails: itemDetailsArray.map(item => ({
    //       kitid: item?.kitId ?? item?.kitid ?? 0,
    //       itemId: item?.ItemId || item?.id || 0,
    //       qty: Number(item?.Quantity) || 0,
    //       issuedQty: Number(item?.IssueQty) || 0,
    //       indentDetailsId: item?.id || 0,
    //       batchNo: selectedBatchNo || item?.batchNo || "string",
    //     })),
    //   }
    // ];

    const transferPayload = [
      {
        issueFormStoreId: getStore?.value || 0,
        indentId:
          transferReceiveItemsList?.[0]?.indentid ??
          transferReceiveItemsList?.[0]?.indent_id ??
          0,
        issueDetails: transferReceiveItemsList
          ?.filter(item => item?.Select)
          ?.map(item => ({
            kitid: item?.kitId ?? item?.kitid ?? 0,
            itemId: item?.ItemId || item?.itemId || 0,
            qty: Number(item?.qty) || 0,
            issuedQty: Number(item?.IssueQty) || 0,
            indentDetailsId: item?.id || 0,
            batchNo: item?.batchNo && item.batchNo.trim() !== ""
              ? item.batchNo
              : "string", // fallback if empty
          })),
      },
    ];

    // const now = new Date().toISOString();

    // // ✅ Step 1: Filter selected items
    // const selectedItems = transferReceiveItemsList?.filter(item => item?.Select) || [];

    // // ✅ Step 2: Group items by kitId
    // const kitMap = new Map();
    // selectedItems.forEach(item => {
    //   const kitId = item?.kitId ?? item?.kitid ?? 0;
    //   if (!kitMap.has(kitId)) {
    //     kitMap.set(kitId, []);
    //   }
    //   kitMap.get(kitId).push(item);
    // });

    // // ✅ Step 3: Build final payload with multiple details per kit
    // const transferPayload = Array.from(kitMap.entries()).map(([kitId, kitItems]) => {
    //   const firstItem = kitItems[0]; // use one item for shared header data
    //   return {
    //     ot_details_id: 0,
    //     item_id: 0,
    //     item_kit_id: kitId,
    //     issuedQuantity: kitItems.reduce((sum, i) => sum + Number(i?.IssueQty || 0), 0),
    //     transitQuantity: 0,
    //     discardedQuantity: 0,
    //     receivedQuantity: 0,
    //     transferDate: now,
    //     transferQty: kitItems.reduce((sum, i) => sum + Number(i?.Quantity || 0), 0),
    //     transferStatus: true,
    //     transferred_by: currentUserId || 0,
    //     from_store_id: getStore?.value || 0,
    //     to_store_id: selectedToStore?.value || 0,
    //     unit_id: 0,
    //     kitBatchNo: firstItem?.kitBatchNo || "string",
    //     cssdLotNo: firstItem?.cssdLotNo || "string",
    //     createdBy: currentUserId || "system",
    //     lastModifiedBy: currentUserId || "system",
    //     createdDate: now,
    //     lastModifiedDate: now,

    //     // ✅ multiple items inside details[]
    //     details: kitItems.map(item => ({
    //       id: 0,
    //       ot_details_id: 0,
    //       item_id: item?.ItemId || item?.itemId || 0,
    //       indentdetailid: item?.id || 0,
    //       indent_id: item?.indentid ?? item?.indent_id ?? 0,
    //       item_kit_id: kitId,
    //       kit_name: item?.KitName || "string",
    //       quantity: Number(item?.qty) || 0,
    //       transferDate: now,
    //       transferQty: Number(item?.Quantity) || 0,
    //       transferStatus: true,
    //       transferred_by: currentUserId || 0,
    //       issueDate: now,
    //       issueStatus: true,
    //       issueQty: Number(item?.IssueQty) || 0,
    //       issued_by: currentUserId || 0,
    //       disposedDate: now,
    //       disposedQty: true,
    //       disposed_by: 0,
    //       disposedReason: "string",
    //       receiveDate: now,
    //       receiveQty: 0,
    //       receiveStatus: true,
    //       received_by: 0,
    //       cleaningStatus: true,
    //       decontaminationStatus: true,
    //       cleanedQty: 0,
    //       cleaned_by: 0,
    //       cleaningStartDate: now,
    //       cleaningEndDate: now,
    //       wrappedQty: 0,
    //       wrappingStatus: true,
    //       wrapped_by: 0,
    //       wrapper_type_id: 0,
    //       wrapperTypeQty: 0,
    //       wrapping_method_id: 0,
    //       wrappingStartDate: now,
    //       wrappingEndDate: now,
    //       sterilizationQty: 0,
    //       sterilizationStatus: true,
    //       sterilizationStatusType: "string",
    //       sterilization_start_by: 0,
    //       sterilizationStartDate: now,
    //       sterilizationEndDate: now,
    //       sterilization_end_by: 0,
    //       machine_id: 0,
    //       sterilization_type_id: 0,
    //       sterilization_method: 0,
    //       sterilizationExpiryDate: now,
    //       addToStockQty: 0,
    //       temperature: 0,
    //       pressure: 0,
    //       durationMinutes: 0,
    //       indicatorResult: "string",
    //       from_store_id: getStore?.value || 0,
    //       to_store_id: selectedToStore?.value || 0,
    //       kitBatchNo:
    //         item?.batchNo && item.batchNo.trim() !== ""
    //           ? item.batchNo
    //           : "string",
    //       itemBatchNo: item?.itemBatchNo || "string",
    //       cssdLotNo: item?.cssdLotNo || "string",
    //       createdBy: currentUserId || "system",
    //       lastModifiedBy: currentUserId || "system",
    //       createdDate: now,
    //       lastModifiedDate: now,
    //     })),
    //   };
    // });


    try {
      const response = await saveTransferCssdItemsListTransfer(transferPayload);
      console.log("✅ API Response:", response);

      if (response?.status === 200 || response?.status === 201) {
        successAlert("Transfer data saved successfully!");

        try {
          setTransferReceiveItemsList([]);
          setTransferReceiveKitItemsList([]);
          setTransferReceiveKitList?.([]);
          setTransferCSSDList([]);
          setKitItemOption?.("kit");
          setSearchString?.("");
          setGetItemType?.("Kit");

          if (typeof fetchCssdKitRequests === "function") {
            await fetchCssdKitRequests();
          } else {
            console.warn("⚠️ fetchCssdKitRequests not defined.");
          }

        } catch (refreshErr) {
          console.error("⚠️ Error refreshing data:", refreshErr);
        }
      } else {
        errorAlert("Failed to save Kit Request.");
      }
    } catch (err) {
      console.error("❌ API Error:", err);
      errorAlert("Something went wrong while saving Kit Request.");
    }

  };

  const renderReceiveCssdKitItem = (row, index, header, kitId) => {
    if (header === "Select") {
      return (
        <Checkbox
          size="small"
          checked={row?.Select || false}   // UI reads state
          onChange={(e) =>
            handleCssdItemChange(kitId, index, "Select", e.target.checked) // updates state
          }
        />
      );
    }

    if (header === "Receive Qty") {
      return (
        <TextField
          size="small"
          type="number"
          value={row.ReceiveQty || ""}
          onChange={(e) =>
            handleCssdItemChange(kitId, index, "ReceiveQty", e.target.value)
          }
        />
      );
    }

    return row[header] || "";
  };



  const fetchCssdKitRequests = async () => {
    try {
      const res = await saveCssdIndentDetails();
      setTransferReceiveKitItemsList(res?.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch CSSD Kits:", err);
    }
  }

  const handleSelectClick = (row) => {
    // row will contain kitid and indent_id
    if (!row?.kitid || !row?.indent_id) {
      console.warn("Missing kitid or indent_id in row");
      return;
    }

    fetchitemkfromkit(row.kitid, row.issueid)
      .then((response) => {
        const result = response?.data?.result || [];

        const mapped = result.map((val) => ({
          Select: false,
          // "Item Code": val?.["Item Code"],
          // "Item Name": val?.["Item Name"],
          // "Disposed Qty": val?.["Disposed Qty"],
          // "Disposed Reason": val?.["Disposed Reason"],
          ...val,
          // "Issue Qty": val?.["Issue Qty"],
          // "Receive Qty": val?.["Receive Qty"],
        }));

        setTransferReceiveItemsList(mapped);
      })
      .catch((err) => {
        console.error("Error fetching items from kit:", err);
      });
  };


  // const populateTransferTable = (forPagination = false) => {
  //   const payload = {
  //     searchString: searchString || "",
  //     searchId: null,
  //     fromDate: fromDate || null,
  //     toDate: toDate || null,
  //     page: !forPagination ? 0 : transferPage,
  //     size: transferRowsPerPage,
  //     processType: "Transfer",
  //   };

  //   fetchIndentData(payload).then((response) => {
  //     const list = response?.data?.result?.map((val) => ({
  //       Select: false, // initialize Select column
  //       ...val,
  //     }));

  //     if (forPagination) {
  //       setTransferCSSDList((prevData) => [...prevData, ...list]);
  //     } else {
  //       setTransferCSSDList(list || []);
  //       setTransferPage(0); // reset page
  //     }
  //     setTransferCount(response.data.count || list?.length || 0);
  //   });
  // };


  // const [kitsInitialized, setKitsInitialized] = useState(false);

  // useEffect(() => {
  //   if (!kitsInitialized && transferReceiveKitList && transferReceiveKitList.length > 0) {
  //     // ✅ Mark all as selected
  //     const allSelected = transferReceiveKitList.map(kit => ({
  //       ...kit,
  //       Select: true,
  //     }));

  //     // ✅ Update the list
  //     setTransferReceiveKitList(allSelected);

  //     // ✅ Wait for React state update, then populate all
  //     setTimeout(() => {
  //       allSelected.forEach(kit => {
  //         populateKitItemTable(kit.id, kit.KitName);
  //       });
  //     }, 300); // Small delay ensures table & checkboxes rendered

  //     setKitsInitialized(true);
  //   }
  // }, [transferReceiveKitList, kitsInitialized]);


  useEffect(() => {
    if (transferReceiveKitList?.length > 0) {
      const allChecked = transferReceiveKitList.map(kit => ({
        ...kit,
        Select: true,
      }));
      setTransferReceiveKitList(allChecked);
      if (selectedScreen === "CSSD Kit Request") {
        allChecked.forEach(kit => populateKitItemTable(kit.id, kit.KitName));
      }
    }
  }, [transferReceiveKitList.length]);


  const populateTransferTableindent = (forPagination = false) => {
    const payload = {
      searchString: null,
      searchId: null,
      fromDate: fromDate || null,
      toDate: toDate || null,
      page: !forPagination ? 0 : transferPage,
      size: transferRowsPerPage,
      processType: "Transfer",
    };

    fetchIndentData(payload).then((response) => {
      const list = response?.data?.result?.map((val, i) => ({
        Select: true,
        ...val,
        id: val.id || i,
      }));

      setTransferCSSDList(list || []);
      setTransferCount(response.data.count || list?.length || 0);
      setTransferPage(0);

      // ✅ populate items for all checked kits once
      setTimeout(() => {
        list.forEach((kit) => {
          populateKitItemTable(kit.id, kit.KitName);
        });
      }, 300);
    });
  };


  const populateTransferTable = (forPagination = false) => {
    const payload = {
      searchString: null,
      searchId: null,
      fromDate: fromDate || null,
      toDate: toDate || null,
      page: !forPagination ? 0 : transferPage,
      size: transferRowsPerPage,
      processType: "Transfer",
    };

    fetchIndentData(payload).then((response) => {
      const list = response?.data?.result?.map((val, i) => ({
        Select: false, // initialize Select column
        ...val,
        // kitName: val?.kitName || "-",
        id: val.id || i, // add unique id if API does not provide one
      }));

      if (forPagination) {
        setTransferCSSDList((prevData) => [...prevData, ...list]);
      } else {
        setTransferCSSDList(list || []);
        setTransferPage(0); // reset page
      }
      setTransferCount(response.data.count || list?.length || 0);
    });
  };

  useEffect(() => {
    if (selectedScreen === "Transfer") {
      populateTransferTable(false);
    }
  }, [selectedScreen, searchString, fromDate, toDate, transferPage, transferRowsPerPage]);


  const renderInputTransfer = (row, index, header) => {
    return row[header];
  };

  let getFromDate = watch("fromDate");
  let getToDate = watch("toDate");
  let getItemType = watch("itemType");
  let getStore = watch("toStore");

  const populateItemTable = (forPagination) => {
    let listObj = {
      searchString: null,
      searchId: null,
      fromDate: listingObject?.fromDate,
      toDate: listingObject?.toDate,
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      processType: selectedScreen === "Receive" ? "receive" : "transfer",
      kitId: null,
    };
    fetchCssdKitItemById(listObj).then((response) => {
      if (forPagination) {
        setTransferReceiveItemsList((prevData) => [
          ...prevData,
          ...response.data.result?.map((val) => ({
            Select: true,
            "Item Code": val?.["Item Code"],
            "Item Name": val?.["Item Name"],
            "Disposed Qty": val?.["Disposed Qty"],
            "Disposed Reason": val?.["Disposed Reason"],
            ...val,
            "Issue Qty":
              selectedScreen === "Transfer"
                ? val?.["Transfer Qty"]
                : val?.["Issue Qty"],
            "Old Issue Qty":
              selectedScreen === "Transfer" ? val?.["Transfer Qty"] : "",
            "Receive Qty":
              selectedScreen === "Receive"
                ? val?.["Issue Qty"]
                : val?.["Receive Qty"],
            "Old Receive Qty":
              selectedScreen === "Receive" ? val?.["Issue Qty"] : "",
          })),
        ]);
      } else {
        setTransferReceiveItemsList(
          response.data.result?.map((val) => ({
            Select: true,
            "Item Code": val?.["Item Code"],
            "Item Name": val?.["Item Name"],
            "Disposed Qty": val?.["Disposed Qty"],
            "Disposed Reason": val?.["Disposed Reason"],
            ...val,
            "Issue Qty":
              selectedScreen === "Transfer"
                ? val?.["Transfer Qty"]
                : val?.["Issue Qty"],
            "Old Issue Qty":
              selectedScreen === "Transfer" ? val?.["Transfer Qty"] : "",
            "Receive Qty":
              selectedScreen === "Receive"
                ? val?.["Issue Qty"]
                : val?.["Receive Qty"],
            "Old Receive Qty":
              selectedScreen === "Receive" ? val?.["Issue Qty"] : "",
          }))
        );
        setPage(0);
      }
      setCount(response.data.count);
    });
  };


  // const populateKitTable = (forPagination) => {
  //   if (!["Receive"].includes(selectedScreen)) return;

  //   let listObj = {
  //     searchString: null,
  //     searchId: null,
  //     fromDate: listingObject?.fromDate,
  //     toDate: listingObject?.toDate,
  //     page: !forPagination ? 0 : page,
  //     size: rowsPerPage,
  //     processType: selectedScreen === "Receive" ? "receive" : "transfer",
  //   };
  //   fetchTransferCssdItemsKitList(listObj).then((response) => {
  //     if (forPagination) {
  //       setTransferReceiveKitList((prevData) => [
  //         ...prevData,
  //         ...response?.data?.result?.map((val) => ({
  //           Select: false,
  //           ...val,
  //         })),
  //       ]);
  //     } else {
  //       setTransferReceiveKitList(
  //         response.data.result?.map((val) => ({
  //           Select: false,
  //           ...val,
  //         }))
  //       );
  //       setKitPage(0);
  //     }
  //     setKitCount(response.data.count);
  //   });
  // };


  // const populateKitItemTable = (id, KitName, kitId, kitName, srNo) => {
  //   let listObj = {
  //     searchString: "",
  //     searchId: null,
  //     fromDate: null,
  //     toDate: null,
  //     processType: selectedScreen === "Receive" ? "receive" : "transfer",
  //     kitId: kitId,
  //     page: null,
  //     size: null,
  //   };

  //   fetchCssdKitItemById(id, KitName, listObj).then((response) => {
  //     let newItems =
  //       response?.data?.statusCode === 200
  //         ? response?.data?.result?.map((val) => ({
  //           Select: true,
  //           "id": val?.["id"],
  //           kitid: val?.KitId ?? val?.kitid ?? id ?? 0,
  //           // "Item Code": val?.["Item Code"],
  //           // "Item Name": val?.["Label"],
  //           // "Disposed Qty": val?.["Disposed Qty"],
  //           // "Disposed Reason": val?.["Disposed Reason"],
  //           ...val,
  //           "Quantity":
  //             selectedScreen === "Transfer"
  //               ? val?.["Transfer Qty"]
  //               : val?.["Quantity"],
  //           // "IssueQty":
  //           //   selectedScreen === "Transfer"
  //           //     ? val?.["Transfer Qty"]
  //           //     : val?.["IssueQty"],
  //           // "Old Issue Qty":
  //           //   selectedScreen === "Transfer" ? val?.["Transfer Qty"] : "",
  //           // "Receive Qty":
  //           //   selectedScreen === "Receive"
  //           //     ? val?.["Issue Qty"]
  //           //     : val?.["Receive Qty"],
  //           // "Old Receive Qty":
  //           //   selectedScreen === "Receive" ? val?.["Issue Qty"] : "",
  //         }))
  //         : [];
  //     let kitObj = {
  //       id: id,
  //       kitName: kitName,
  //       KitName,
  //       srNo: srNo,
  //       kitItemList: newItems?.length > 0 ? newItems : [],
  //     };
  //     setTransferReceiveKitItemsList((prevData) => [
  //       ...prevData,
  //       { ...kitObj },
  //     ]);
  //   });
  // };


  const populateKitTable = (forPagination = false) => {
    if (selectedScreen !== "Receive") return;

    let listObj = {
      searchString: null,
      searchId: null,
      fromDate: listingObject?.fromDate,
      toDate: listingObject?.toDate,
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      processType: "receive",
    };

    fetchTransferCssdItemsKitList(listObj).then((response) => {
      const result = response?.data?.result || [];

      const formattedList = result.map((val) => ({
        Select: false,
        ...val,
      }));

      if (forPagination) {
        setTransferReceiveKitList((prev) => [...prev, ...formattedList]);
      } else {
        setTransferReceiveKitList(formattedList);
        setKitPage(0);
      }

      setKitCount(response.data.count || result.length);
    });
  };

  const populateKitItemTable = (id, KitName, kitId, kitName, srNo) => {
    const listObj = {
      searchString: "",
      searchId: null,
      fromDate: null,
      toDate: null,
      processType: selectedScreen === "Receive" ? "receive" : "transfer",
      kitId: kitId || id,
      page: null,
      size: null,
    };

    fetchCssdKitItemById(id, KitName, listObj).then((response) => {
      let newItems =
        response?.data?.statusCode === 200
          ? response?.data?.result?.map((val) => ({
            Select: true,
            id: val?.id,
            kitid: val?.KitId ?? id ?? 0,
            ...val,
            Quantity:
              selectedScreen === "Transfer"
                ? val?.["Transfer Qty"]
                : val?.["Quantity"],
          }))
          : [];

      const kitObj = {
        id,
        KitName,
        kitItemList: newItems,
      };

      // ✅ Prevent duplicates
      setTransferReceiveKitItemsList((prevData) => {
        const existing = prevData.find((k) => k.id === id);
        if (existing) {
          return prevData.map((k) => (k.id === id ? kitObj : k));
        } else {
          return [...prevData, kitObj];
        }
      });
    });
  };

  const populateKitItemTableTransferOT = (id, kitBatchNo, kitId, KitName, srNo) => {
    const listObj = {
      searchString: "",
      searchId: null,
      fromDate: null,
      toDate: null,
      processType: selectedScreen === "Receive" ? "receive" : "transfer",
      kitId: kitId || id,
      page: null,
      size: null,
    };

    fetchCssdStockByIdAndBatch(id, kitBatchNo)
      .then((response) => {
        let newItems =
          response?.data?.statusCode === 200
            ? response?.data?.result?.map((val) => ({
              Select: true,
              id: val?.id,
              // kitid: val?.KitId ?? id ?? 0,
              item_id: val?.itemId ?? id ?? 0,
              ...val,
              kitBatchNo: val?.batchCode || kitBatchNo || "",
              Quantity: val?.["qty"] || 0,
              "KitName": val?.["KitName"],

            }))
            : [];

        const kitObj = {
          id,
          KitName,
          batchCode: kitBatchNo, // ✅ add batchCode to first table
          kitItemList: newItems,
        };

        // ✅ Prevent duplicates
        setTransferReceiveKitItemsList((prevData) => {
          const existing = prevData.find((k) => k.id === id);
          if (existing) {
            return prevData.map((k) => (k.id === id ? kitObj : k));
          } else {
            return [...prevData, kitObj];
          }
        });
      })
      .catch((error) => {
        console.error("Error fetching kit stock:", error);
      });
  };

  // useEffect(() => {
  //   if (transferReceiveKitList?.length > 0) {
  //     // Only update Select if there is at least one unchecked kit
  //     const needsUpdate = transferReceiveKitList.some(kit => !kit.Select);

  //     if (needsUpdate) {
  //       const allChecked = transferReceiveKitList.map((kit) => {
  //         const match = kit.KitName.match(/^(.*)\((.*)\)$/); // Extract name and batch
  //         return {
  //           ...kit,
  //           Select: true,
  //           // KitName: match ? match[1].trim() : kit.KitName,
  //           kitBatchNo: match ? match[2].trim() : "",
  //         };
  //       });

  //       setTransferReceiveKitList(allChecked);

  //       // Fetch items for each kit using ID and Batch No
  //       allChecked.forEach((kit) => {
  //         if (kit.kitBatchNo) {
  //           populateKitItemTableTransferOT(kit.id, kit.kitBatchNo);
  //         }
  //       });
  //     }
  //   }
  // }, [transferReceiveKitList]);

  // const populateKitItemTableTransferOT = (id, KitName, kitBatchNo) => {
  //   fetchCssdStockByIdAndBatch(id, kitBatchNo)
  //     .then((response) => {
  //       if (response?.data?.statusCode !== 200) return;

  //       // Map each item to include proper fields
  //       const newItems = response.data.result.map((val) => ({
  //         Select: true,
  //         id: val?.id,
  //         kitId: val?.kitId ?? id,
  //         KitName: val?.KitName ?? KitName,
  //         ItemId: val?.itemId,
  //         ItemName: val?.ItemName,
  //         Quantity:
  //           selectedScreen === "Transfer"
  //             ? Number(val?.["Transfer Qty"] || val?.qty || 0)
  //             : Number(val?.qty || 0),
  //         kitBatchNo: val?.batchCode || kitBatchNo || "",
  //         storeId: val?.storeId || 0,
  //         batchCode: val?.batchCode || kitBatchNo || "",
  //         ...val, // include any other API fields
  //       }));

  //       // Construct kit object
  //       const kitObj = {
  //         id,
  //         KitName,
  //         batchCode: kitBatchNo,
  //         kitItemList: newItems,
  //       };

  //       // Update state without duplicates
  //       setTransferReceiveKitItemsList((prevData) => {
  //         const exists = prevData.find((k) => k.id === id);
  //         if (exists) {
  //           return prevData.map((k) => (k.id === id ? kitObj : k));
  //         } else {
  //           return [...prevData, kitObj];
  //         }
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching kit stock:", error);
  //     });
  // };

  useEffect(() => {
    if (transferReceiveKitList?.length > 0) {
      // Only update Select if there is at least one unchecked kit
      const needsUpdate = transferReceiveKitList.some(kit => !kit.Select);

      if (needsUpdate) {
        const allChecked = transferReceiveKitList.map((kit) => {
          const kitNameStr = kit.KitName || ""; // ✅ fallback to empty string
          const match = kitNameStr.match(/^(.*)\((.*)\)$/); // Extract name and batch

          return {
            ...kit,
            Select: true,
            // Optionally update KitName without batch
            // KitName: match ? match[1].trim() : kitNameStr,
            kitBatchNo: match ? match[2].trim() : "", // batch code
          };
        });

        setTransferReceiveKitList(allChecked);

        // Fetch items for each kit using ID and batch number
        allChecked.forEach((kit) => {
          if (kit.kitBatchNo) {
            populateKitItemTableTransferOT(
              kit.id,
              kit.kitBatchNo,
              kit.kitId,      // optional if needed
              kit.KitName,    // optional if needed
              kit.srNo        // optional if needed
            );
          }
        });
      }
    }
  }, [transferReceiveKitList]);


  const populateReceiveKitItemTable = (id, KitName, kitBatchNo) => {
    fetchTransferReceiveCssdItemsList(id, kitBatchNo).then((response) => {
      const newItems =
        response?.data?.result?.map((val) => ({
          Select: true,
          id: val?.id,
          kitId: val?.kitId ?? id,
          // KitName: kitName,
          "KitName": val?.["KitName"],
          "ItemCode": val?.["itemId"],
          "BatchNo": val?.["BatchNo"],
          "Item Name": val?.["itemName"],
          "Quantity": val?.["qty"],
          // ...val,
        })) ?? [];

      const kitObj = {
        id,
        KitName: KitName,
        kitItemList: newItems,
      };

      setReceiveKitItemsList((prevData) => [...prevData, kitObj]);
    });
  };


  // const populateReceiveKitItemTableOT = (id, KitName, kitBatchNo) => {
  //   fetchTransferReceiveCssdItemsListOT(id, kitBatchNo).then((response) => {
  //     const newItems =
  //       response?.data?.result?.map((val) => ({
  //         Select: true,
  //         id: val?.id,
  //         kitId: val?.kitId ?? id,
  //         // KitName: kitName,
  //         "KitName": val?.["KitName"],
  //         "ItemCode": val?.["item_id"],
  //         "BatchNo": val?.["kitBatchNo"],
  //         "Item Name": val?.["ItemName"],
  //         "Quantity": val?.["quantity"],
  //         // ...val,
  //       })) ?? [];

  //     const kitObj = {
  //       id,
  //       KitName: KitName,
  //       kitItemList: newItems,
  //     };

  //     setReceiveKitItemsList((prevData) => [...prevData, kitObj]);
  //   });
  // };

  const populateReceiveKitItemTableOT = (id, KitName, kitBatchNo) => {
    fetchTransferReceiveCssdItemsListOT(id, kitBatchNo).then((response) => {
      const result = response?.data?.result || [];

      const newItems = result.map((val) => ({
        Select: true,

        // id
        id: val?.id || val?.indentdetailid || 0,

        // kitId (if 0, keep as 0 but DO NOT move into another tab)
        kitId: val?.kitId ?? val?.item_kit_id ?? 0,

        // Kit name (same tab for all)
        KitName: val?.KitName || val?.kitName || KitName || "",
        // item fields
        ItemCode: val?.item_id || "",
        BatchNo: val?.kitBatchNo || "",
        "Item Name": val?.ItemName || "",
        Quantity: Number(val?.quantity || 0),

      }));

      const kitObj = {
        id,
        KitName: KitName,
        kitItemList: newItems,   // 🚀 includes kitId=0 + kitId>0 items together
      };

      setReceiveKitItemsList((prev) => [...prev, kitObj]);
    });
  };


  const renderInputItem = (row, index, header) => {
    setValue(`disposedReason${row?.["Sr No"]}`, row?.["Disposed Reason"]);
    return (
      <div className="-my-2">
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`Select${row?.["Sr No"]}`}
            checked={row?.Select}
            onChange={(e) => {
              setTransferReceiveItemsList((prevTransferItemList) =>
                prevTransferItemList.map((val, i) =>
                  val?.["Item Code"] === row?.["Item Code"] &&
                    val?.["Sr No"] === row?.["Sr No"]
                    ? { ...val, Select: e.target.checked }
                    : val
                )
              );
            }}
          />
        )}
        {header === "Issue Qty" && (
          <input
            type="number"
            value={row?.["Issue Qty"]}
            name={`issueQty${row?.["Sr No"]}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveItemsList((prevTransferItemList) =>
                prevTransferItemList.map((val, i) =>
                  val?.["Item Code"] === row?.["Item Code"] &&
                    val?.["Sr No"] === row?.["Sr No"]
                    ? { ...val, "Issue Qty": e.target.value }
                    : val
                )
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}
        {header === "Receive Qty" && (
          <input
            type="number"
            value={row?.["Receive Qty"]}
            name={`receiveQty${row?.["Sr No"]}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveItemsList((prevTransferItemList) =>
                prevTransferItemList.map((val, i) =>
                  val?.["Item Code"] === row?.["Item Code"] &&
                    val?.["Sr No"] === row?.["Sr No"]
                    ? { ...val, "Receive Qty": e.target.value }
                    : val
                )
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}
        {header === "Disposed Qty" && (
          <input
            type="number"
            value={Number(row?.["Disposed Qty"])}
            name={`disposedQty${row?.["Sr No"]}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              if (
                (selectedScreen === "Transfer" &&
                  e.target.value <= Number(row?.["Old Issue Qty"])) ||
                (selectedScreen === "Receive" &&
                  e.target.value <= Number(row?.["Old Receive Qty"]))
              ) {
                setTransferReceiveItemsList((prevTransferItemList) =>
                  prevTransferItemList.map((val, i) =>
                    val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? {
                        ...val,
                        "Disposed Qty": e.target.value,
                        "Issue Qty":
                          e.target.value !== "" &&
                            selectedScreen === "Transfer"
                            ? val?.["Old Issue Qty"] - e.target.value
                            : val?.["Old Issue Qty"],
                        "Receive Qty":
                          e.target.value !== "" &&
                            selectedScreen === "Receive"
                            ? val?.["Old Receive Qty"] - e.target.value
                            : val?.["Old Receive Qty"],
                      }
                      : val
                  )
                );
              }
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}
        {header === "Disposed Reason" && (
          <input
            type="text"
            name={`disposedReason${row?.["Sr No"]}`}
            value={row?.["Disposed Reason"]}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveItemsList((prevTransferItemList) =>
                prevTransferItemList.map((val, i) =>
                  val?.["Item Code"] === row?.["Item Code"] &&
                    val?.["Sr No"] === row?.["Sr No"]
                    ? { ...val, "Disposed Reason": e.target.value }
                    : val
                )
              );
            }}
          />
        )}
      </div>
    );
  };

  // 1️⃣ Flatten all items from all kits
  const allItems = receiveKitItemsList.flatMap(kit =>
    kit.kitItemList?.map(item => ({
      ...item,
      KitName: item.KitName,
      parentKitId: kit.id
    })) || []
  );

  // 2️⃣ Group items by item.kitId (NOT parent kit id)
  const groupedItems = allItems.reduce((acc, item) => {
    const key = item.kitId ?? 0;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  // 3️⃣ Convert groups to final tab array
  const finalTabs = Object.entries(groupedItems).map(([kitId, items]) => ({
    kitId,
    KitName: items[0]?.KitName || `Kit ${kitId}`,
    items,
  }));

  // const renderInputKitTransferOTs = (row, index, header) => {
  //   if (header !== "Select") return null;

  //   const handleCheck = (isChecked) => {
  //     // Update Select flag
  //     setTransferReceiveKitList((prevData) =>
  //       prevData.map((kit) =>
  //         kit.id === row.id ? { ...kit, Select: isChecked } : kit
  //       )
  //     );

  //     if (isChecked) {
  //       if (transferReceiveKitItemsList?.length === 0) setValues(0);

  //       populateKitItemTableTransferOT(
  //         row.id,
  //         row.kitBatchNo,   // correct batch number
  //         row.kitId,
  //         row.KitName,
  //         row.srNo
  //       );
  //     } else {
  //       setTransferReceiveKitItemsList((prev) =>
  //         prev.filter((val) => val.id !== row.id)
  //       );
  //     }
  //   };

  //   return (
  //     <div className="-my-2">
  //       <Checkbox
  //         size="small"
  //         name={`SelectKit${row?.id}`}
  //         checked={!!row?.Select}       // ✅ FIXED → no auto-check
  //         onChange={(e) => handleCheck(e.target.checked)}
  //       />
  //     </div>
  //   );
  // };

  // const renderInputKitTransferOTs = (row, index, header) => {
  //   if (header !== "Select") return null;

  //   const handleCheck = async (isChecked) => {
  //     // Update Select flag
  //     setTransferReceiveKitList((prevData) =>
  //       prevData.map((kit) =>
  //         kit.id === row.id ? { ...kit, Select: isChecked } : kit
  //       )
  //     );

  //     if (isChecked) {
  //       if (!row.kitBatchNo) return console.warn("Kit batch number missing!");

  //       if (transferReceiveKitItemsList?.length === 0) setValues(0);

  //       try {
  //         const response = await fetchCssdStockByIdAndBatch(row.id, row.kitBatchNo);
  //         const data = response.data;

  //         if (data?.result?.length > 0) {
  //           setTransferReceiveKitItemsList((prev) => [
  //             ...prev,
  //             ...data.result.map((item) => ({
  //               id: item.id,
  //               ItemId: item.ItemId,
  //               KitName: row.KitName,
  //               ItemName: item.ItemName,
  //               Quantity: item.Quantity,
  //             })).filter(newItem => !prev.some(prevItem => prevItem.id === newItem.id)) // remove duplicates
  //           ]);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching kit stock:", error);
  //       }
  //     } else {
  //       // Remove items from table if unchecked
  //       setTransferReceiveKitItemsList((prev) =>
  //         prev.filter((val) => val.KitName !== row.KitName)
  //       );
  //     }
  //   };

  //   return (
  //     <div className="-my-2">
  //       <Checkbox
  //         size="small"
  //         name={`SelectKit${row?.id}`}
  //         checked={row?.Select || false}
  //         onChange={(e) => handleCheck(e.target.checked)}
  //       />
  //     </div>
  //   );
  // };


  const renderInputKitTransferOTs = (row, index, header) => {
    if (header !== "Select") return null;

    const handleCheck = (isChecked) => {
      // Update Select flag
      setTransferReceiveKitList((prevData) =>
        prevData.map((kit) =>
          kit.id === row.id ? { ...kit, Select: isChecked } : kit
        )
      );

      if (isChecked) {
        populateKitItemTableTransferOT(
          row.id,
          row.kitBatchNo,
          row.kitId,
          row.KitName,
          row.srNo
        );
      } else {
        // Remove tab data immediately
        setTransferReceiveKitItemsList((prev) =>
          prev.filter((item) => item.kitId !== row.kitId)
        );
      }
    };

    return (
      <div className="-my-2">
        <Checkbox
          size="small"
          name={`SelectKit${row?.id}`}
          checked={!!row?.Select}
          onChange={(e) => handleCheck(e.target.checked)}
        />
      </div>
    );
  };

  const renderInputKit = (row, index, header) => {
    return (
      <div className="-my-2">
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`SelectKit${row?.id}`}
            checked={row?.Select || false}
            onChange={(e) => {
              const isChecked = e.target.checked;

              setTransferReceiveKitList((prevData) =>
                prevData.map((kit) =>
                  kit.id === row.id ? { ...kit, Select: isChecked } : kit
                )
              );

              if (isChecked) {
                if (transferReceiveKitItemsList?.length === 0) {
                  setValues(0);
                }
                populateKitItemTable(
                  // row?.["Item Kit Code"],
                  // row?.["Item Kit Name"],
                  // row?.["Sr No"],
                  row?.id,
                  row?.KitName,
                );
              } else {
                // Remove this row from the tab list
                setTransferReceiveKitItemsList((prev) =>
                  prev.filter((val) => val.id !== row.id)
                );
              }
            }}
          />
        )}
      </div>
    );
  };

  // const renderInputKitReceive = (row, index, header) => {
  //   return (
  //     <div className="flex items-center space-x-2 -my-2">
  //       {/* Checkbox column */}
  //       {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           name={`SelectKit${row?.id}`}
  //           checked={row?.Select || false}
  //           onChange={(e) => {
  //             const isChecked = e.target.checked;

  //             // Update kit selection
  //             setTransferReceiveKitList((prevData) =>
  //               prevData.map((kit) =>
  //                 kit.id === row.id ? { ...kit, Select: isChecked } : kit
  //               )
  //             );

  //             if (isChecked) {
  //               setValues(row.id);
  //               populateReceiveKitItemTable(row.id, row.KitName, row.kitBatchNo);
  //             } else {
  //               setReceiveKitItemsList((prev) =>
  //                 prev.filter((val) => val.id !== row.id)
  //               );
  //             }
  //           }}
  //         />
  //       )}

  //       {/* KitName column */}
  //       {header === "KitName" && (
  //         <span className="font-semibold">{row.KitName || "No Name"}</span>
  //       )}
  //     </div>
  //   );
  // };

  // const renderInputKitReceive = (row, index, header) => {
  //   return (
  //     <div className="flex items-center space-x-2 -my-2">
  //       {/* Checkbox column */}
  //       {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           name={`SelectKit${row?.id}`}
  //           // checked={false} // Always render unchecked
  //           checked={!!selectedKits[row.id] || false}
  //           onChange={(e) => {
  //             const isChecked = e.target.checked;

  //             // Update only this row's selection in state
  //             setTransferReceiveKitList((prevData) =>
  //               prevData.map((kit) =>
  //                 kit.id === row.id ? { ...kit, Select: isChecked } : kit
  //               )
  //             );

  //             if (isChecked) {
  //               setValues(row.id);
  //               populateReceiveKitItemTable(row.id, row.KitName, row.kitBatchNo);
  //             } else {
  //               setReceiveKitItemsList((prev) =>
  //                 prev.filter((val) => val.id !== row.id)
  //               );
  //             }
  //           }}
  //         />
  //       )}

  //       {/* KitName column */}
  //       {header === "KitName" && (
  //         <span className="font-semibold">{row.KitName || "No Name"}</span>
  //       )}
  //     </div>
  //   );
  // };

  const renderInputKitTransferOT = (row, index, header) => {
    return (
      <div className="flex items-center space-x-2 -my-2">
        {/* Checkbox column */}
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`SelectKit${row?.id}`}
            // Controlled by local state, not row.Select
            checked={!!selectedKits[row.id] || false}
            onChange={(e) => {
              const isChecked = e.target.checked;

              // Update local selection state
              setSelectedKits((prev) => ({
                ...prev,
                [row.id]: isChecked,
              }));

              // Optional: update your main kit list if needed
              setTransferReceiveKitList((prevData) =>
                prevData.map((kit) =>
                  kit.id === row.id ? { ...kit, Select: isChecked } : kit
                )
              );

              if (isChecked) {
                setValues(row.id);
                populateReceiveKitItemTableOT(row.id, row.KitName, row.kitBatchNo);
              } else {
                setReceiveKitItemsList((prev) =>
                  prev.filter((val) => val.id !== row.id)
                );
              }
            }}
          />
        )}

        {/* KitName column */}
        {header === "KitName" && (
          <span className="font-semibold">{row.KitName || "No Name"}</span>
        )}
      </div>
    );
  };

  // 🧩 Your render function

  // In your component state
  const [selectedKits, setSelectedKits] = useState({}); // { [kitId]: true/false }

  const renderInputKitReceive = (row, index, header) => {
    return (
      <div className="flex items-center space-x-2 -my-2">
        {/* Checkbox column */}
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`SelectKit${row?.id}`}
            // Controlled by local state, not row.Select
            checked={!!selectedKits[row.id] || false}
            onChange={(e) => {
              const isChecked = e.target.checked;

              // Update local selection state
              setSelectedKits((prev) => ({
                ...prev,
                [row.id]: isChecked,
              }));

              // Optional: update your main kit list if needed
              setTransferReceiveKitList((prevData) =>
                prevData.map((kit) =>
                  kit.id === row.id ? { ...kit, Select: isChecked } : kit
                )
              );

              if (isChecked) {
                setValues(row.id);
                populateReceiveKitItemTable(row.id, row.KitName, row.kitBatchNo);
              } else {
                setReceiveKitItemsList((prev) =>
                  prev.filter((val) => val.id !== row.id)
                );
              }
            }}
          />
        )}

        {/* KitName column */}
        {header === "KitName" && (
          <span className="font-semibold">{row.KitName || "No Name"}</span>
        )}
      </div>
    );
  };

  const renderInputKitItemTransferOT = (row, index, header) => {
    return (
      <div className="flex items-center space-x-2 -my-2">
        {header === "BatchNo" && (
          <span>{row.kitBatchNo || row.batchCode || "-"}</span>
        )}

        {header === "Select" && (
          <Checkbox
            size="small"
            checked={row?.Select || false}
            onChange={(e) => {
              const isChecked = e.target.checked;
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj.map((kit) => ({
                  ...kit,
                  kitItemList: kit.kitItemList.map((val) =>
                    val?.id === row.id ? { ...val, Select: isChecked } : val
                  ),
                }))
              );
            }}
          />
        )}

        {header === "ItemName" && <span>{row.ItemName}</span>}

        {header === "Quantity" && (
          <input
            type="number"
            value={row?.Quantity || ""}
            className="border border-black rounded w-24 px-2"
            onChange={(e) => {
              const value = e.target.value;
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj.map((kit) => ({
                  ...kit,
                  kitItemList: kit.kitItemList.map((val) =>
                    val?.id === row.id ? { ...val, Quantity: value } : val
                  ),
                }))
              );
            }}
          />
        )}

        {/* Other columns like IssueQty, Receive Qty, Disposed Qty, Disposed Reason */}
      </div>
    );
  };


  const renderInputKitItem = (row, index, header) => {
    setValue(`${values}disposedReason${index}`, row?.["Disposed Reason"]);
    return (
      <div className="-my-2">
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`${values}SelectKitItem${index}`}
            checked={row?.Select}
            onChange={(e) => {
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, Select: e.target.checked }
                      : val
                  ),
                }))
              );
            }}
          />
        )}
        {header === "IssueQty" && (
          <input
            type="number"
            value={row?.["Issue Qty"]}
            name={`${values}issueQty${index}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, "Issue Qty": e.target.value }
                      : val
                  ),
                }))
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}
        {header === "Receive Qty" && (
          <input
            type="number"
            value={row?.["Receive Qty"]}
            name={`${values}receiveQty${index}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, "Receive Qty": e.target.value }
                      : val
                  ),
                }))
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}
        {header === "Quantity" && (
          <input
            type="number"
            value={row?.["Quantity"]}
            name={`${values}quantity${index}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, "Quantity": e.target.value }
                      : val
                  ),
                }))
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(e.key) &&
              e.preventDefault()
            }
          />
        )}

        {header === "Disposed Qty" && (
          <input
            type="number"
            value={Number(row?.["Disposed Qty"])}
            name={`${values}disposedQty${index}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              if (
                (selectedScreen === "Transfer" &&
                  e.target.value <= Number(row?.["Old Issue Qty"])) ||
                (selectedScreen === "Receive" &&
                  e.target.value <= Number(row?.["Old Receive Qty"]))
              ) {
                setTransferReceiveKitItemsList((prevDataObj) =>
                  prevDataObj?.map((kit, kitInd) => ({
                    ...kit,
                    kitItemList: kit.kitItemList?.map((val) =>
                      values === kitInd &&
                        val?.["Item Code"] === row?.["Item Code"] &&
                        val?.["Sr No"] === row?.["Sr No"]
                        ? {
                          ...val,
                          "Disposed Qty": e.target.value,
                          "Issue Qty":
                            e.target.value !== "" &&
                              selectedScreen === "Transfer"
                              ? val?.["Old Issue Qty"] - e.target.value
                              : val?.["Old Issue Qty"],
                          "Receive Qty":
                            e.target.value !== "" &&
                              selectedScreen === "Receive"
                              ? val?.["Old Receive Qty"] - e.target.value
                              : val?.["Old Receive Qty"],
                        }
                        : val
                    ),
                  }))
                );
              }
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}
        {header === "Disposed Reason" && (
          <input
            type="text"
            name={`${values}disposedReason${index}`}
            value={row?.["Disposed Reason"]}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, "Disposed Reason": e.target.value }
                      : val
                  ),
                }))
              );
            }}
          />
        )}
      </div>
    );
  };

  const renderReceiveKitItem = (row, index, header) => {
    // Pre-fill disposed reason for form validation or tracking
    setValue(`${values}disposedReason${index}`, row?.["Disposed Reason"]);

    return (
      <div className="-my-2">
        {/* ✅ Checkbox for selecting item */}
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`${values}SelectKitItem${index}`}
            checked={row?.Select || false}
            onChange={(e) => {
              const checked = e.target.checked;
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, Select: checked }
                      : val
                  ),
                }))
              );
            }}
          />
        )}

        {/* ✅ Receive Quantity Input */}
        {header === "Receive Qty" && (
          <input
            type="number"
            value={row?.["Receive Qty"] || ""}
            name={`${values}receiveQty${index}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, "Receive Qty": e.target.value }
                      : val
                  ),
                }))
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}

        {/* ✅ Quantity Input */}
        {header === "Quantity" && (
          <input
            type="number"
            value={row?.["Quantity"] || ""}
            name={`${values}quantity${index}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, Quantity: e.target.value }
                      : val
                  ),
                }))
              );
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}

        {/* ✅ Disposed Quantity Input */}
        {header === "Disposed Qty" && (
          <input
            type="number"
            value={row?.["Disposed Qty"] || 0}
            name={`${values}disposedQty${index}`}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              const newValue = e.target.value;
              if (newValue <= Number(row?.["Old Receive Qty"])) {
                setTransferReceiveKitItemsList((prevDataObj) =>
                  prevDataObj?.map((kit, kitInd) => ({
                    ...kit,
                    kitItemList: kit.kitItemList?.map((val) =>
                      values === kitInd &&
                        val?.["Item Code"] === row?.["Item Code"] &&
                        val?.["Sr No"] === row?.["Sr No"]
                        ? {
                          ...val,
                          "Disposed Qty": newValue,
                          "Receive Qty":
                            newValue !== ""
                              ? val?.["Old Receive Qty"] - newValue
                              : val?.["Old Receive Qty"],
                        }
                        : val
                    ),
                  }))
                );
              }
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}

        {/* ✅ Disposed Reason Input */}
        {header === "Disposed Reason" && (
          <input
            type="text"
            name={`${values}disposedReason${index}`}
            value={row?.["Disposed Reason"] || ""}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              setTransferReceiveKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, "Disposed Reason": e.target.value }
                      : val
                  ),
                }))
              );
            }}
          />
        )}
      </div>
    );
  };

  const [selectAll, setSelectAll] = useState(false);

  // const renderInputTransferkit = (row, index, header) => {
  //   return (
  //     <div className="-my-2">
  //       {header === "Select" && (
  //         <Checkbox
  //           size="small"
  //           checked={selectAll}
  //           onChange={async (e) => {
  //             const isChecked = e.target.checked;
  //             setSelectAll(isChecked);

  //             // Update all rows
  //             setTransferCSSDList((prev) =>
  //               prev.map((kit) => ({ ...kit, Select: isChecked }))
  //             );

  //             if (isChecked) {
  //               // Fetch items for ALL kits
  //               try {
  //                 const allItems = [];

  //                 for (const kit of transferCSSDList) {
  //                   const response = await fetchitemkfromkit(kit.id || 0);
  //                   const items = response?.data?.result || [];

  //                   allItems.push(
  //                     ...items.map((val) => ({
  //                       Select: true,
  //                       kitId: kit.kitid || 0,
  //                       "Batch No": val?.["Batch No"],
  //                       ...val,
  //                     }))
  //                   );
  //                 }

  //                 setTransferReceiveItemsList(allItems);
  //               } catch (err) {
  //                 console.error("Error fetching all kits:", err);
  //               }
  //             } else {
  //               // ❌ Uncheck all → show nothing
  //               setTransferReceiveItemsList([]);
  //             }
  //           }}
  //         />

  //       )}
  //       {header !== "Select" && row[header]}
  //     </div>
  //   );
  // };

  const renderInputTransferkit = (row, index, header) => {
    return (
      <div className="-my-2">
        {header === "Select" && (
          <Checkbox
            size="small"
            checked={row.Select || false}
            onChange={async (e) => {
              const isChecked = e.target.checked;

              // ✅ update clicked row only
              setTransferCSSDList((prev) =>
                prev.map((kit, i) =>
                  i === index ? { ...kit, Select: isChecked } : kit
                )
              );

              if (isChecked) {
                // ✅ ADD items for selected checkbox
                try {
                  const response = await fetchitemkfromkit(row.id || 0);
                  const items = response?.data?.result || [];

                  setTransferReceiveItemsList((prev) => [
                    ...prev,
                    ...items.map((val) => ({
                      Select: true,
                      kitId: row.kitid || 0,
                      "Batch No": val?.["Batch No"],
                      ...val,
                    })),
                  ]);
                } catch (err) {
                  console.error(err);
                }
              } else {
                // ✅ REMOVE only unchecked row items
                setTransferReceiveItemsList((prev) =>
                  prev.filter((item) => item.kitId !== row.kitid)
                );
              }
            }}
          />
        )}

        {header !== "Select" && row[header]}
      </div>
    );
  };

  const [selectedBatchNo, setSelectedBatchNo] = useState("");

  const renderInputTransferkitItem = (row, index, header, kitIndex) => {
    return (
      <div className="-my-2">

        {header === "Select" && (
          <Checkbox
            size="small"
            checked={row?.Select || true}
            onChange={() => { }}
          />
        )}


        {header === "Batch No" && (
          <input
            type="text"
            name={`batchNo_${kitIndex}_${index}`}
            value={
              row?.batchNo && row.batchNo.trim() !== ""
                ? row.batchNo
                : selectedBatchNo || ""
            } // Prefill with dropdown value, but always editable
            onChange={(e) => {
              const newValue = e.target.value;
              setTransferReceiveKitItemsList((prevData) =>
                prevData.map((kit, kIndex) =>
                  kIndex === kitIndex
                    ? {
                      ...kit,
                      kitItemList: kit.kitItemList.map((item, i) =>
                        i === index ? { ...item, batchNo: newValue } : item
                      ),
                    }
                    : kit
                )
              );
            }}
            className="border border-gray-300 rounded-md px-1 py-0.5 text-sm w-28 focus:outline-none focus:ring-2 focus:ring-blue-400"
            placeholder="Enter Batch No"
          />
        )}

        {/* ✅ Other columns */}
        {header !== "Select" && header !== "Batch No" && row[header]}
      </div>
    );
  };


  const addToStockList = () => {
    let itemDetailsArray =
      getItemType === "Item"
        ? transferReceiveItemsList?.filter((fil) => fil.Select === true)
        : transferReceiveKitItemsList
          ?.flatMap((val) => val?.kitItemList)
          ?.filter((fil) => fil.Select === true);
    let postObject = {
      id: null,
      fromStore:
        selectedScreen === "Transfer"
          ? getUserInfo?.loginStoreId
          : getStore?.id,
      toStore:
        selectedScreen === "Transfer"
          ? getStore?.id
          : getUserInfo?.loginStoreId,
      itemDetailsRequestDtoList: itemDetailsArray
        ?.filter((val) => val?.Select === true)
        ?.map((item) => ({
          id: item?.Id,
          cssdTransferId: item?.["Cssd Transfer Id"]
            ? item?.["Cssd Transfer Id"]
            : null,
          otDetails:
            item?.["Ot Details Id"] !== null
              ? {
                id: item?.["Ot Details Id"],
              }
              : null,
          item:
            item?.["Item Id"] !== null
              ? {
                id: item?.["Item Id"],
              }
              : null,
          itemKit:
            item?.["Item Kit Code"] !== null
              ? {
                id: item?.["Item Kit Code"],
              }
              : null,
          transferDate: item?.["Transfer Date"]
            ? item?.["Transfer Date"]?.replace(" ", "T")?.split(".")[0]
            : null,
          transferQty: item?.["Transfer Qty"]
            ? Number(item?.["Transfer Qty"])
            : null,
          transferStatus: item?.["Transfer Status"] === "true" ? true : false,
          transferredBy:
            item?.["Transferred By"] !== null
              ? { id: item?.["Transferred By"] }
              : null,

          issueDate:
            selectedScreen === "Transfer"
              ? format(new Date(), "yyyy-MM-dd'T'HH:mm:ss")
              : item?.["Issue Date"]
                ? item?.["Issue Date"]?.replace(" ", "T")?.split(".")[0]
                : null,
          issueStatus:
            selectedScreen === "Transfer" ? true : item?.["Issue Status"],
          issueQty: item?.["Issue Qty"] ? Number(item?.["Issue Qty"]) : null,
          issuedBy:
            selectedScreen === "Transfer"
              ? { id: getUserInfo?.employeeId }
              : item?.["Issued By"]
                ? { id: item?.["Issued By"] }
                : null,

          disposedDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
          disposedQty: item?.["Disposed Qty"]
            ? Number(item?.["Disposed Qty"])
            : null,
          disposedBy: { id: getUserInfo?.employeeId },

          receiveDate:
            selectedScreen === "Receive"
              ? format(new Date(), "yyyy-MM-dd'T'HH:mm:ss")
              : item?.["Receive Date"]
                ? item?.["Receive Date"]?.replace(" ", "T")?.split(".")[0]
                : null,
          receiveQty: item?.["Receive Qty"]
            ? Number(item?.["Receive Qty"])
            : null,
          receiveStatus:
            selectedScreen === "Receive" ? true : item?.["Receive Status"],
          receivedBy:
            selectedScreen === "Receive"
              ? { id: getUserInfo?.employeeId }
              : item?.["Received By"]
                ? { id: item?.["Received By"] }
                : null,

          cleaningStatus: item?.["Cleaning Status"] === "true" ? true : false,
          cleanedQty:
            item?.["Cleaned Qty"] !== null
              ? Number(item?.["Cleaned Qty"])
              : null,
          cleaningStartDate:
            item?.["Cleaning Start Date"] !== null
              ? item?.["Cleaning Start Date"]?.replace(" ", "T")
              : null,
          cleaningEndDate:
            item?.["Cleaning End Date"] !== null
              ? item?.["Cleaning End Date"]?.replace(" ", "T")
              : null,
          cleanedBy:
            item?.["Cleaned By"] !== null ? { id: item?.["Cleaned By"] } : null,

          wrappedQty:
            item?.["Wrapped Qty"] !== null
              ? Number(item?.["Wrapped Qty"])
              : null,
          wrappingStatus: item?.["Wrapping Status"] === "true" ? true : false,
          wrappedBy:
            item?.["Wrapped By"] !== null ? { id: item?.["Wrapped By"] } : null,
          wrapperType:
            item?.["Wrapper Type Id"] !== null
              ? { id: item?.["Wrapper Type Id"] }
              : null,
          wrappingMethod:
            item?.["Wrapping Method Id"] !== null
              ? { id: item?.["Wrapping Method Id"] }
              : null,
          wrappingStartDate:
            item?.["Wrapping Start Date"] !== null
              ? item?.["Wrapping Start Date"]?.replace(" ", "T")
              : null,
          wrappingEndDate:
            item?.["Wrapping End Date"] !== null
              ? item?.["Wrapping End Date"]?.replace(" ", "T")
              : null,

          sterilizationQty:
            item?.["Sterilization Qty"] !== null
              ? Number(item?.["Sterilization Qty"])
              : null,
          sterilizationStatus:
            item?.["Sterilization Status"] === "true" ? true : false,
          sterilizationStatusType: item?.["Sterilization Status Type"],
          sterilizationStartBy:
            item?.["Sterilization Start By"] !== null
              ? { id: item?.["Sterilization Start By"] }
              : null,
          sterilizationEndBy:
            item?.["Sterilization End By"] !== null
              ? { id: item?.["Sterilization End By"] }
              : null,
          sterilizationStartDate:
            item?.["Sterilization Start Date"] !== null
              ? item?.["Sterilization Start Date"]?.replace(" ", "T")
              : null,
          sterilizationEndDate:
            item?.["Sterilization End Date"] !== null
              ? item?.["Sterilization End Date"]?.replace(" ", "T")
              : null,
          sterilizationEndBy:
            item?.["Sterilization End By"] !== null
              ? { id: item?.["Sterilization End By"] }
              : null,
          sterilizationType:
            item?.["Sterilization Equipment Id"] !== null
              ? { id: item?.["Sterilization Equipment Id"] }
              : null,
          sterilizationMethod:
            item?.["Sterilization Method Id"] !== null
              ? { id: item?.["Sterilization Method Id"] }
              : null,
          sterilizationExpiryDate:
            item?.["Sterilization ExpiryDate"] !== null
              ? item?.["Sterilization ExpiryDate"]?.replace(" ", "T")
              : null,

          addToStockQty:
            item?.["AddToStock Qty"] !== null
              ? Number(item?.["AddToStock Qty"])
              : null,

          decontaminationStatus:
            item?.["Decontamination Status"] === "true" ? true : false,

          kitBatchNo: item?.["Kit BatchNo"],
          itemBatchNo: item?.["Item BatchNo"],
          processType: selectedScreen === "Receive" ? "receive" : "transfer",
        })),
    };
    console.log("postObject", postObject);

    setOpenPostModal(false);
    setOpenBackdrop(true);
    saveTransferCssdItemsList(postObject)
      .then((response) => {
        successAlert(response.data.message);
        if (getItemType === "Kit") {
          populateKitTable();
          setTransferReceiveKitItemsList([]);
        } else {
          populateItemTable();
        }
        setOpenBackdrop(false);
      })
      .catch((error) => {
        // errorAlert(error.message);
        setOpenBackdrop(false);
      });
  };

  // const handleItemKitChange = (autoSearchString) => {
  //   if (autoSearchString !== "") {
  //     autoSearchCssdItemKit(autoSearchString, "cssd")
  //       .then((response) => response.data)
  //       .then((res) => {
  //         setItemKitOptions(res.result);
  //       });
  //   }
  // };

  // const handleCssdReceiveCheckbox = async (row, checked) => {
  //   try {
  //     if (checked) {
  //       const response = await fetchTransferCssdItemsList(row.item_kit_id, row.kitBatchNo);

  //       console.log("CSSD Receive Data:", response.data);

  //       setSelectedCssdKit(row.item_kit_id);
  //       setCssdReceiveItemList(response.data);
  //     } else {
  //       setSelectedCssdKit(null);
  //       setCssdReceiveItemList([]);
  //     }
  //   } catch (error) {
  //     console.error("Failed to load CSSD receive kit details", error);
  //   }
  // };

  const handleCssdReceiveCheckbox = (row, isChecked) => {
    const updatedList = receiveCssdKitItemsList.map(kit => ({
      ...kit,
      kitItemList: kit.kitItemList.map(item =>
        item.id === row.id ? { ...item, Select: isChecked } : item
      )
    }));
    setReceiveCssdKitItemsList(updatedList);
  };


  useMemo(() => {
    if (getItemType === "Item") {
      populateItemTable();
    } else if (getItemType === "Kit") {
      populateKitTable();
      // populateKitItemTableTransferOT();
      setTransferReceiveKitItemsList([]);
    }
  }, [listingObject?.fromDate, listingObject?.toDate, getItemType]);

  useEffect(() => {
    if (getItemType === "Item") {
      setTransferReceiveItemsList([]);
      populateItemTable();
      setTransferReceiveKitList([]);
      setTransferReceiveKitItemsList([]);
    } else if (getItemType === "Kit") {
      setTransferReceiveKitList([]);
      populateKitTable();
      setTransferReceiveKitItemsList([]);
      setTransferReceiveItemsList([]);
    }
    setValue("toStore", null);
  }, [selectedScreen]);
  // const handleKitCheckboxChange = async (rowIndex) => {
  //   setTransferReceiveKitList((prevList) =>
  //     prevList.map((row, index) => {
  //       if (index === rowIndex) {
  //         return { ...row, Select: !row.Select };
  //       }
  //       return row;
  //     })
  //   );

  //   const selectedRow = transferReceiveKitList[rowIndex];


  //   // const selectedBatchNo = option?.batchno ?? "";



  //   // Call API only when checkbox is selected
  //   if (!selectedRow.Select) {
  //     const selectedId = option?.id ?? option?.value ?? "";

  //     try {
  //       const res = await fetchCssdKitItemById(String(selectedId));
  //       const kitItems =
  //         res?.data?.result?.map((item) => ({
  //           id: item?.["itemId"] || item?.["kitId"] || selectedRow.id,
  //           BatchNo: item?.["kitBatchNo"] ?? item?.["BatchNo"] ?? selectedRow.BatchNo,
  //           Label: item?.["Item Name"] || selectedRow.Label,
  //         })) || [];
  //       setTransferReceiveKitItemsList(kitItems);
  //     } catch (error) {
  //       console.error("Error fetching kit items:", error);
  //       setTransferReceiveKitItemsList([]);
  //     }
  //   }
  // };

  // const handleKitCheckboxChange = async (rowIndex) => {
  //   // Toggle the checkbox first
  //   setTransferReceiveKitList((prevList) =>
  //     prevList.map((row, index) => {
  //       if (index === rowIndex) {
  //         return { ...row, Select: !row.Select };
  //       }
  //       return row;
  //     })
  //   );

  //   // Get the row AFTER toggling the checkbox
  //   const selectedRow = transferReceiveKitList[rowIndex];
  //   const isChecking = !selectedRow.Select; // will be true if now checking

  //   if (isChecking) {
  //     try {
  //       // Ensure ID is primitive
  //       const kitId = selectedRow.id?.id ?? selectedRow.id;
  //       const res = await fetchCssdKitItemById(String(kitId));

  //       const kitItems =
  //         res?.data?.result?.map((item) => ({
  //           id: item?.["itemId"] || item?.["kitId"] || kitId,
  //           BatchNo: item?.["kitBatchNo"] ?? item?.["BatchNo"] ?? selectedRow.BatchNo,
  //           Label: item?.["Item Name"] || selectedRow.Label,
  //         })) || [];

  //       setTransferReceiveKitItemsList(kitItems);
  //     } catch (error) {
  //       console.error("Error fetching kit items:", error);
  //       setTransferReceiveKitItemsList([]);
  //     }
  //   } else {
  //     // If unchecked, clear kit items
  //     setTransferReceiveKitItemsList([]);
  //   }
  // };
  // 🔹 Debounce to reduce API hits


  // const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [batchOptions, setBatchOptions] = useState([]);

  const handleSearch = async (value) => {
    if (!value?.trim()) return;
    try {
      setLoading(true);
      const response = await fetchBatchNoList(value);
      const result = response?.data?.result || [];
      setBatchOptions(Array.isArray(result) ? result : []);
    } catch (error) {
      console.error("Error fetching batch numbers:", error);
      setBatchOptions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleIndentRequestSearch = async () => {
    try {
      const payload = {
        searchString: watch("searchByItem") || null,
        searchId: null,
        storeId: watch("toStore")?.value || null,
        fromDate: format(getFromDate, "yyyy-MM-dd"),
        toDate: format(getToDate, "yyyy-MM-dd"),
        page: page,
        size: rowsPerPage,
        processType: "Transfer"
      };

      const res = await fetchIndentData(payload);

      const tableData = (res?.data?.result || []).map(item => ({
        Select: false,
        ...item
      }));

      setTransferCSSDList(tableData);

    } catch (error) {
      console.error("Search API Error:", error);
    }
  };

  const handleReceiveSearch = async () => {
    try {
      const payload = {
        searchString: watch("searchByItem") || null,
        page: kitPage,
        size: kitRowsPerPage,
        fromDate: format(getFromDate, "yyyy-MM-dd"),
        toDate: format(getToDate, "yyyy-MM-dd"),
        searchId: null,
        processType: "Receive",
        storeId: watch("toStore")?.value ?? null
      };

      console.log("Receive Payload:", payload);

      const res = await fetchTransferCssdItemsKitList(payload);

      const tableData = (res?.data?.result || []).map(item => ({
        Select: false,
        ...item
      }));

      setTransferReceiveKitList(tableData);

    } catch (error) {
      console.error("Receive API Error:", error);
    }
  };

  const handleReceiveCSSDSearch = async () => {
    try {
      const payload = {
        searchString: watch("searchByItem") || null,
        page: kitPage,
        size: kitRowsPerPage,
        fromDate: format(getFromDate, "yyyy-MM-dd"),
        toDate: format(getToDate, "yyyy-MM-dd"),
        searchId: null,
        processType: "ReceiveCSSD",
        storeId: watch("toStore")?.value ?? null
      };

      console.log("ReceiveCSSD Payload:", payload);

      const res = await fetchTransferCssdItemsKitListCSSDRe(payload);

      const tableData = (res?.data?.result || []).map(item => ({
        Select: false,
        ...item
      }));

      setReceiveCssdList(tableData);

    } catch (error) {
      console.error("ReceiveCSSD API Error:", error);
    }
  };


  const handleReset = () => {
    reset();
    setSelectedBatchNo("");
    setValues(null);
    setPage(0);
  };

  const [values, setValues] = useState(null);

  const handleChange = (event, newValue) => {
    setValues(newValue);
  };

  console.log("transferReceiveKitItemsList", transferReceiveKitItemsList);
  console.log("transferReceiveKitList", transferReceiveKitList);
  console.log("transferReceiveItemsList", transferReceiveItemsList);

  return (
    <div className="px-4">

      {/* <div className="flex items-center justify-center mt-14">
        {screenType?.map((val, idx) => (
          <fieldset
            disabled={selectedScreen === val}
            key={idx}
            className={`px-2 py-1 whitespace-nowrap font-semibold cursor-pointer border border-customBlue ${selectedScreen === val
              ? "bg-customBlue text-white"
              : "bg-white text-customBlue"
              }`}
            onClick={() => {
              setSelectedScreen(val);
            }}
          >
            
            <span className="mr-1">{val}</span>
            {idx !== 0 && <span className="text font-semibold">CSSD Items</span>}
          </fieldset>
        ))}
      </div> */}

      {/* 
      <div className="flex flex-col items-center space-y-6 mt-4 w-full">
        <div className="flex">
          <button
            onClick={() => {
              setSelectedRole("OT");
              setSelectedScreen("CSSD Kit Request");
            }}
            className={`px-2 py-1 font-semibold border  border-customBlue ${selectedRole === "OT"
              ? "bg-customBlue text-white"
              : "bg-white text-customBlue"
              }`}
          >
            OT
          </button>

          <button
            onClick={() => {
              setSelectedRole("CSSD");
              setSelectedScreen("Transfer");
            }}
            className={`px-2 py-1 font-semibold border border-customBlue ${selectedRole === "CSSD"
              ? "bg-customBlue text-white"
              : "bg-white text-customBlue"
              }`}
          >
            CSSD
          </button>
        </div>

        <div className="flex items-center justify-center mt-5">
          {filteredTabs.map((val, idx) => (
            <fieldset
              disabled={selectedScreen === val}
              key={idx}
              className={`px-2 py-1 whitespace-nowrap font-semibold cursor-pointer border border-customBlue ${selectedScreen === val
                ? "bg-customBlue text-white"
                : "bg-white text-customBlue"
                }`}
              onClick={() => setSelectedScreen(val)}
            >
              {val === "CSSD Kit Request" ? (
                <span>{val}</span>
              ) : (
                <>
                  <span className="mr-1">{val}</span>
                  <span className="text font-semibold">CSSD Items</span>
                </>
              )}
            </fieldset>
          ))}
        </div>
      </div> */}

<div className="flex flex-col items-center space-y-6 mt-4 w-full">

  {/* Hidden Role Buttons */}
  <div className="hidden">
    <button
      onClick={() => {
        setSelectedRole("Operation Theatre");
        setSelectedScreen("CSSD Kit Request");
      }}
      className={`px-2 py-1 font-semibold border border-customBlue ${
        selectedRole === "Operation Theatre"
          ? "bg-customBlue text-white"
          : "bg-white text-customBlue"
      }`}
    >
      OT
    </button>

    <button
      onClick={() => {
        setSelectedRole("Cssd");
        setSelectedScreen("Transfer");
      }}
      className={`px-2 py-1 font-semibold border border-customBlue ${
        selectedRole === "Cssd"
          ? "bg-customBlue text-white"
          : "bg-white text-customBlue"
      }`}
    >
      CSSD
    </button>
  </div>

  {/* Tabs */}
  <div className="flex items-center justify-center mt-5">
    {filteredTabs.map((val, idx) => {

      const isActive =
        selectedScreen === val ||
        (val === "Transfer" && selectedScreen === "TransferOT") ||
        (val === "Receive" && selectedScreen === "ReceiveCSSD");

      const displayName =
        selectedRole === "Cssd" && val === "Transfer"
          ? "Indent Requests"
          : val;

      return (
        <fieldset
          key={idx}
          disabled={isActive}
          className={`px-2 py-1 whitespace-nowrap font-semibold cursor-pointer border border-customBlue ${
            isActive
              ? "bg-customBlue text-white"
              : "bg-white text-customBlue"
          }`}
          onClick={() => {

            if (selectedRole === "Operation Theatre" && val === "Transfer") {
              setSelectedScreen("TransferOT");
            } 

            else if (selectedRole === "Cssd" && val === "Receive") {
              setSelectedScreen("ReceiveCSSD");
              handleCssdReceiveFetch();
            } 

            else {
              setSelectedScreen(val);
            }

          }}
        >
          {selectedRole === "Cssd" && val === "Transfer" ? (
            <span>{displayName}</span>
          ) : val === "CSSD Kit Request" ? (
            <span>{displayName}</span>
          ) : (
            <>
              <span className="mr-1">{displayName}</span>
              <span className="font-semibold">CSSD Items</span>
            </>
          )}
        </fieldset>
      );
    })}
  </div>
</div>

      {/* <div className="filters w-full mt-2 px-2">

        {selectedScreen === "CSSD Kit Request" ? (
          <div className="w-full">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 justify-start">

              <div className="flex items-center space-x-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="kitItemOption"
                    value="kit"
                    checked={kitItemOption === "kit"}
                    onChange={(e) => setKitItemOption(e.target.value)}
                    className="cursor-pointer accent-blue-600"
                  />
                  <span className="text-sm font-medium">Kit</span>
                </label>

                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="kitItemOption"
                    value="item"
                    checked={kitItemOption === "item"}
                    onChange={(e) => setKitItemOption(e.target.value)}
                    className="cursor-pointer accent-blue-600"
                  />
                  <span className="text-sm font-medium">Item</span>
                </label>
              </div>

              <div className="flex min-w-[250px] sm:min-w-[300px] md:min-w-[400px] lg:min-w-[500px]">

                <SearchBar
                  key={searchKey} // force remount on kit or item addition
                  name="searchByItem"
                  placeholder={`Search ${kitItemOption === "kit" ? "Kit" : "Item"}`}
                  dataArray={options}
                  value={selectedItem}
                  onChange={(option) => {
                    if (!option) return;

                    const selectedId = option?.id ?? option?.value ?? "";

                    if (kitItemOption === "kit") {
                      // Add kit to the kit list
                      setTransferReceiveKitList((prevList) => {
                        const exists = prevList.some((kit) => kit.id === selectedId);
                        if (exists) return prevList;

                        return [
                          ...prevList,
                          {
                            Select: false,
                            id: selectedId,
                            KitName: option?.label || "",
                          },
                        ];
                      });
                    } else {
                      // Add item to the "Others" tab
                      const fetchItem = async () => {
                        try {
                          const res = await fetchCssdItems("item");
                          const selectedItemData = res?.data?.result?.find(
                            (item) => String(item.id) === String(selectedId)
                          );
                          if (!selectedItemData) return;

                          setTransferReceiveKitItemsList((prevList) => {
                            const exists = prevList.some((kit) => kit.id === "others");
                            const newItem = {
                              Select: true,
                              id: selectedItemData.id,
                              ItemId: selectedItemData.id,
                              KitName: selectedItemData["Item Name"] || option?.label || "",
                              Quantity: selectedItemData["Quantity"] || 1,
                              // IssueQty: selectedItemData["IssueQty"] || 1,
                            };

                            if (!exists) {
                              return [...prevList, { id: "others", KitName: "Others", kitItemList: [newItem] }];
                            } else {
                              return prevList.map((kit) => {
                                if (kit.id === "others") {
                                  const itemExists = kit.kitItemList.some(i => i.id === selectedItemData.id);
                                  if (!itemExists) {
                                    return { ...kit, kitItemList: [...kit.kitItemList, newItem] };
                                  }
                                }
                                return kit;
                              });
                            }
                          });
                        } catch (err) {
                          console.error("Error fetching item:", err);
                        }
                      };
                      fetchItem();
                    }

                    // 🔹 Refresh SearchBar after kit or item is added
                    setSelectedItem(null);
                    setSearchKey((prev) => prev + 1);
                  }}
                  handleInputChange={handleInputChange}
                  isSearchable
                  isClearable
                  loading={loading}
                  searchIcon={true}
                />
              </div>

              <div className="flex min-w-[180px] sm:min-w-[200px] md:min-w-[300px] lg:min-w-[400px]">
                <DropdownField
                  control={control}
                  name="toStore"
                  placeholder="To Store"
                  dataArray={storeOptions}
                  error={errors.toStore}
                  isSearchable={true}
                />
              </div>

              <div className="flex flex-row space-x-2 justify-start">
                <CommonButton
                  type="button"
                  searchIcon={true}
                  className="bg-customBlue text-white"
                  onClick={() => {
                    setListingObject((listingObject) => ({
                      ...listingObject,
                      fromDate: format(getFromDate, "dd-MM-yyyy"),
                      toDate: format(getToDate, "dd-MM-yyyy"),
                    }));
                  }}
                />
                <CommonButton
                  type="button"
                  label="Reset"
                  className="border border-customRed text-customRed"
                />
              </div>


              <div className="ml-auto">
                <CommonButton
                  type="button"
                  label="Previous Request List"
                  className="bg-customBlue text-white"
                  onClick={() => setOpenPreviousListModal(true)}
                />
              </div>

            </div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
              <SearchBar
                name="searchByItem"
                placeholder="Search By Item / Kit Name"
                searchIcon={true}
                isClearable={true}
              />
              <div className="grid grid-cols-2 gap-2">
                <DatePickerField
                  control={control}
                  name="fromDate"
                  label="From Date"
                  inputFormat="dd-MM-yyyy"
                />
                <DatePickerField
                  control={control}
                  name="toDate"
                  label="To Date"
                  inputFormat="dd-MM-yyyy"
                />
              </div>
              <DropdownField
                control={control}
                name="toStore"
                placeholder={`${selectedScreen === "Transfer" ? "To Store" : "From Store"
                  }`}
                dataArray={storeOptions}
                error={errors.toStore}
                isSearchable={true}
              />

              <div className="flex space-x-2 col-span-1 sm:col-span-2 lg:col-span-1 justify-start">
                <CommonButton
                  type="button"
                  searchIcon={true}
                  className="bg-customBlue text-white"
                  onClick={() => {
                    setListingObject((listingObject) => ({
                      ...listingObject,
                      fromDate: format(getFromDate, "dd-MM-yyyy"),
                      toDate: format(getToDate, "dd-MM-yyyy"),
                    }));
                  }}
                />
                <CommonButton
                  type="button"
                  label="Reset"
                  className="border border-customRed text-customRed"
                />
              </div>

              <div className="flex justify-end col-span-1 sm:col-span-2 xl:col-span-1">
                <CommonButton
                  type="button"
                  label={`${selectedScreen === "Transfer"
                    ? "Previous Transfer List"
                    : "Previous Receive List"
                    }`}
                  className="bg-customBlue text-white"
                  onClick={() => setOpenPreviousListModal(true)}
                />
              </div>
            </div>
          </>
        )}
      </div> */}

      <div className="filters w-full mt-2 px-2">

        {selectedScreen === "CSSD Kit Request" && (
          <div className="w-full">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 justify-start">


              <div className="flex items-center space-x-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="kitItemOption"
                    value="kit"
                    checked={kitItemOption === "kit"}
                    onChange={(e) => setKitItemOption(e.target.value)}
                    className="cursor-pointer accent-blue-600"
                  />
                  <span className="text-sm font-medium">Kit</span>
                </label>

                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="kitItemOption"
                    value="item"
                    checked={kitItemOption === "item"}
                    onChange={(e) => setKitItemOption(e.target.value)}
                    className="cursor-pointer accent-blue-600"
                  />
                  <span className="text-sm font-medium">Item</span>
                </label>
              </div>


              <div className="flex min-w-[250px] sm:min-w-[300px] md:min-w-[400px] lg:min-w-[500px]">
                <SearchBar
                  key={searchKey}
                  name="searchByItem"
                  placeholder={`Search ${kitItemOption === "kit" ? "Kit" : "Item"}`}
                  dataArray={options}
                  value={selectedItem}
                  onChange={(option) => {
                    if (!option) return;

                    const selectedId = option?.id ?? option?.value ?? "";

                    if (kitItemOption === "kit") {
                      // Add kit
                      setTransferReceiveKitList((prevList) => {
                        const exists = prevList.some((kit) => kit.id === selectedId);
                        if (exists) return prevList;

                        return [
                          ...prevList,
                          {
                            Select: false,
                            id: selectedId,
                            KitName: option?.label || "",
                          },
                        ];
                      });
                    } else {
                      // Add item
                      const fetchItem = async () => {
                        try {
                          const res = await fetchCssdItems("item");
                          const selectedItemData = res?.data?.result?.find(
                            (item) => String(item.id) === String(selectedId)
                          );
                          if (!selectedItemData) return;

                          setTransferReceiveKitItemsList((prevList) => {
                            const exists = prevList.some((kit) => kit.id === "others");
                            const newItem = {
                              Select: true,
                              id: selectedItemData.id,
                              ItemId: selectedItemData.id,
                              ItemName: selectedItemData["Item Name"] || option?.label || "",
                              // kitBatchNo: selectedItemData["kitBatchNo"] || option?.label || "",
                              Quantity: selectedItemData["Quantity"] || 1,
                            };

                            if (!exists) {
                              return [...prevList, { id: "others", KitName: "Others", kitItemList: [newItem] }];
                            } else {
                              return prevList.map((kit) => {
                                if (kit.id === "others") {
                                  const itemExists = kit.kitItemList.some(i => i.id === selectedItemData.id);
                                  if (!itemExists) {
                                    return { ...kit, kitItemList: [...kit.kitItemList, newItem] };
                                  }
                                }
                                return kit;
                              });
                            }
                          });
                        } catch (err) {
                          console.error("Error fetching item:", err);
                        }
                      };
                      fetchItem();
                    }

                    setSelectedItem(null);
                    setSearchKey((prev) => prev + 1);
                  }}
                  handleInputChange={handleInputChange}
                  isSearchable
                  isClearable
                  loading={loading}
                  searchIcon={true}
                />
              </div>


              <div className="flex min-w-[180px] sm:min-w-[200px] md:min-w-[300px] lg:min-w-[400px]">
                <SearchDropdown
                  control={control}
                  name="toStore"
                  placeholder="To Store"
                  dataArray={storeOptions}
                  inputValue={searchBarString}
                  isClearable
                  handleInputChange={handleToStoreChange}
                  onChange={(selected) => {
                    console.log("Selected toStore:", selected);
                  }}
                />
              </div>


              <div className="flex flex-row space-x-2 justify-start">
                <CommonButton
                  type="button"
                  searchIcon={true}
                  className="bg-customBlue text-white"
                  onClick={() => {
                    setListingObject((listingObject) => ({
                      ...listingObject,
                      fromDate: format(getFromDate, "dd-MM-yyyy"),
                      toDate: format(getToDate, "dd-MM-yyyy"),
                    }));
                  }}
                />
                <CommonButton
                  type="button"
                  label="Reset"
                  className="border border-customRed text-customRed"
                />
              </div>


              <div className="ml-auto">
                <CommonButton
                  type="button"
                  label="Previous Request List"
                  className="bg-customBlue text-white"
                  onClick={() => setOpenPreviousListModal(true)}
                />
              </div>
            </div>
          </div>
        )}

        {selectedScreen === "TransferOT" && (
          <div className="w-full">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 justify-start">

              <div className="flex items-center space-x-4">
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="kitItemOption"
                    value="kit"
                    checked={kitItemOption === "kit"}
                    onChange={(e) => setKitItemOption(e.target.value)}
                    className="cursor-pointer accent-blue-600"
                  />
                  <span className="text-sm font-medium">Kit</span>
                </label>

                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="kitItemOption"
                    value="item"
                    checked={kitItemOption === "item"}
                    onChange={(e) => setKitItemOption(e.target.value)}
                    className="cursor-pointer accent-blue-600"
                  />
                  <span className="text-sm font-medium">Item</span>
                </label>
              </div>


              <div className="flex min-w-[250px] sm:min-w-[300px] md:min-w-[400px] lg:min-w-[500px]">
                <SearchBar
                  key={searchKey}
                  name="searchByItem"
                  placeholder={`Search ${kitItemOption === "kit" ? "Kit" : "Item"}`}
                  dataArray={options}
                  value={selectedItem}
                  onChange={(option) => {
                    if (!option) return;

                    const selectedId = option?.id ?? option?.value ?? "";

                    // 🔵 KIT SECTION
                    if (kitItemOption === "kit") {
                      setTransferReceiveKitList((prevList) => {
                        const exists = prevList.some((kit) => kit.id === selectedId);
                        if (exists) return prevList;

                        return [
                          ...prevList,
                          {
                            Select: false,
                            id: selectedId,
                            KitName: option?.label || "",
                          },
                        ];
                      });
                    }

                    // 🔵 ITEM SECTION
                    else {
                      const fetchItem = async () => {
                        try {
                          // 🔥 Single API call for BOTH kit & item
                          const res = await fetchCssdItemsTransferOT("item");

                          const selectedItemData = res?.data?.result?.find(
                            (item) => String(item.id) === String(selectedId)
                          );
                          if (!selectedItemData) return;

                          setTransferReceiveKitItemsList((prevList) => {
                            const othersIndex = prevList.findIndex((kit) => kit.id === "others");

                            const newItem = {
                              Select: true,
                              id: selectedItemData.id,
                              item_id: selectedItemData.id,
                              ItemName:
                                selectedItemData["Item Name"] ||
                                option?.label ||
                                "",
                              kitBatchNo: selectedItemData["batchCode"] || option?.label || "",
                              Quantity: selectedItemData["quantity"] || 1,
                            };

                            // If "Others" group doesn't exist
                            if (othersIndex === -1) {
                              return [
                                ...prevList,
                                { id: "others", KitName: "Others", kitItemList: [newItem] },
                              ];
                            }

                            // If exists → check duplicate
                            const updatedList = [...prevList];
                            const existingItemIndex =
                              updatedList[othersIndex].kitItemList.findIndex(
                                (i) => i.id === newItem.id
                              );

                            if (existingItemIndex > -1) {
                              updatedList[othersIndex].kitItemList[existingItemIndex] = {
                                ...updatedList[othersIndex].kitItemList[existingItemIndex],
                                Quantity:
                                  updatedList[othersIndex].kitItemList[existingItemIndex]
                                    .Quantity + newItem.Quantity,
                              };
                            } else {
                              updatedList[othersIndex].kitItemList.push(newItem);
                            }

                            return updatedList;
                          });
                        } catch (err) {
                          console.error("Error fetching item:", err);
                        }
                      };

                      fetchItem();
                    }

                    // Reset search
                    setSelectedItem(null);
                    setSearchKey((prev) => prev + 1);
                  }}
                  handleInputChange={handleInputChangeTransferOT}
                  isSearchable
                  isClearable
                  loading={loading}
                  searchIcon={true}
                />
              </div>


              <div className="flex min-w-[180px] sm:min-w-[200px] md:min-w-[300px] lg:min-w-[400px]">
                <SearchDropdown
                  control={control}
                  name="toStore"
                  placeholder="To Store"
                  dataArray={storeOptions}
                  inputValue={searchBarString}
                  isClearable
                  handleInputChange={handleToStoreChange}
                  onChange={(selected) => {
                    console.log("Selected toStore:", selected);
                  }}
                />
              </div>


              <div className="flex flex-row space-x-2 justify-start">
                <CommonButton
                  type="button"
                  searchIcon={true}
                  className="bg-customBlue text-white"
                  onClick={() => {
                    setListingObject((listingObject) => ({
                      ...listingObject,
                      fromDate: format(getFromDate, "dd-MM-yyyy"),
                      toDate: format(getToDate, "dd-MM-yyyy"),
                    }));
                  }}
                />
                <CommonButton
                  type="button"
                  label="Reset"
                  className="border border-customRed text-customRed"
                />
              </div>


              <div className="ml-auto">
                <CommonButton
                  type="button"
                  label="Previous Request List"
                  className="bg-customBlue text-white"
                  onClick={() => setOpenPreviousListModal(true)}
                />
              </div>
            </div>
          </div>
        )}

        {selectedScreen === "Transfer" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">

            <SearchBar
              name="searchByItem"
              placeholder="Search By Item / Kit Name"
              searchIcon={true}
              isClearable={true}
            />

            <div className="grid grid-cols-2 gap-2">
              <DatePickerField
                control={control}
                name="fromDate"
                label="From Date"
                inputFormat="dd-MM-yyyy"
              />
              <DatePickerField
                control={control}
                name="toDate"
                label="To Date"
                inputFormat="dd-MM-yyyy"
              />
            </div>

            <SearchDropdown
              control={control}
              name="toStore"
              placeholder={`${selectedScreen === "Transfer" ? "To Store" : "From Store"}`}
              dataArray={storeOptions}
              inputValue={searchBarString}
              isClearable
              handleInputChange={handleToStoreChange}
              onChange={(selected) => {
                console.log("Selected toStore:", selected);
              }}
            />

            <div className="flex space-x-2 col-span-1 sm:col-span-2 lg:col-span-1 justify-start">
              <CommonButton
                type="button"
                searchIcon={true}
                className="bg-customBlue text-white"
                onClick={handleIndentRequestSearch}
              />

              <CommonButton
                type="button"
                label="Reset"
                className="border border-customRed text-customRed"
                onClick={handleReset}
              />
            </div>

            <div className="flex justify-end col-span-1 sm:col-span-2 xl:col-span-1">
              <CommonButton
                type="button"
                label={
                  selectedScreen === "Transfer"
                    ? "Previous Transfer List"
                    : "Previous Receive List"
                }
                className="bg-customBlue text-white"
                onClick={() => setOpenPreviousListModal(true)}
              />
            </div>

          </div>
        )}

        {selectedScreen === "Receive" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">

            <SearchBar
              name="searchByItem"
              placeholder="Search By Item / Kit Name"
              searchIcon={true}
              isClearable={true}
            />

            <div className="grid grid-cols-2 gap-2">
              <DatePickerField
                control={control}
                name="fromDate"
                label="From Date"
                inputFormat="dd-MM-yyyy"
              />
              <DatePickerField
                control={control}
                name="toDate"
                label="To Date"
                inputFormat="dd-MM-yyyy"
              />
            </div>

            <SearchDropdown
              control={control}
              name="toStore"
              placeholder={`${selectedScreen === "Transfer" ? "To Store" : "From Store"}`}
              dataArray={storeOptions}
              inputValue={searchBarString}
              isClearable
              handleInputChange={handleToStoreChange}
              onChange={(selected) => {
                console.log("Selected toStore:", selected);
              }}
            />

            <div className="flex space-x-2 col-span-1 sm:col-span-2 lg:col-span-1 justify-start">
              <CommonButton
                type="button"
                searchIcon={true}
                className="bg-customBlue text-white"
                onClick={handleReceiveSearch}
              />

              <CommonButton
                type="button"
                label="Reset"
                className="border border-customRed text-customRed"
                onClick={handleReset}
              />
            </div>

            <div className="flex justify-end col-span-1 sm:col-span-2 xl:col-span-1">
              <CommonButton
                type="button"
                label={
                  selectedScreen === "Transfer"
                    ? "Previous Transfer List"
                    : "Previous Receive List"
                }
                className="bg-customBlue text-white"
                onClick={() => setOpenPreviousListModal(true)}
              />
            </div>

          </div>
        )}

        {selectedScreen === "ReceiveCSSD" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">

            <SearchBar
              name="searchByItem"
              placeholder="Search By Item / Kit Name"
              searchIcon={true}
              isClearable={true}
            />

            <div className="grid grid-cols-2 gap-2">
              <DatePickerField
                control={control}
                name="fromDate"
                label="From Date"
                inputFormat="dd-MM-yyyy"
              />
              <DatePickerField
                control={control}
                name="toDate"
                label="To Date"
                inputFormat="dd-MM-yyyy"
              />
            </div>

            <SearchDropdown
              control={control}
              name="toStore"
              placeholder={`${selectedScreen === "Transfer" ? "To Store" : "From Store"}`}
              dataArray={storeOptions}
              inputValue={searchBarString}
              isClearable
              handleInputChange={handleToStoreChange}
              onChange={(selected) => {
                console.log("Selected toStore:", selected);
              }}
            />

            <div className="flex space-x-2 col-span-1 sm:col-span-2 lg:col-span-1 justify-start">
              <CommonButton
                type="button"
                searchIcon={true}
                className="bg-customBlue text-white"
                onClick={handleReceiveCSSDSearch}
              />

              <CommonButton
                type="button"
                label="Reset"
                className="border border-customRed text-customRed"
                onClick={handleReset}
              />
            </div>

            <div className="flex justify-end col-span-1 sm:col-span-2 xl:col-span-1">
              <CommonButton
                type="button"
                label={
                  selectedScreen === "Transfer"
                    ? "Previous Transfer List"
                    : "Previous Receive List"
                }
                className="bg-customBlue text-white"
                onClick={() => setOpenPreviousListModal(true)}
              />
            </div>

          </div>
        )}

        {selectedScreen !== "CSSD Kit Request" &&
          selectedScreen !== "TransferOT" && selectedScreen !== "Transfer" && selectedScreen !== "Receive" && selectedScreen !== "ReceiveCSSD" && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">

              <SearchBar
                name="searchByItem"
                placeholder="Search By Item / Kit Name"
                searchIcon={true}
                isClearable={true}
              />

              <div className="grid grid-cols-2 gap-2">
                <DatePickerField
                  control={control}
                  name="fromDate"
                  label="From Date"
                  inputFormat="dd-MM-yyyy"
                />
                <DatePickerField
                  control={control}
                  name="toDate"
                  label="To Date"
                  inputFormat="dd-MM-yyyy"
                />
              </div>

              <SearchDropdown
                control={control}
                name="toStore"
                placeholder={`${selectedScreen === "Transfer" ? "To Store" : "From Store"}`}
                dataArray={storeOptions}
                inputValue={searchBarString}
                isClearable
                handleInputChange={handleToStoreChange}
                onChange={(selected) => {
                  console.log("Selected toStore:", selected);
                }}
              />

              <div className="flex space-x-2 col-span-1 sm:col-span-2 lg:col-span-1 justify-start">
                <CommonButton
                  type="button"
                  searchIcon={true}
                  className="bg-customBlue text-white"
                  onClick={() => {
                    setListingObject((listingObject) => ({
                      ...listingObject,
                      fromDate: format(getFromDate, "dd-MM-yyyy"),
                      toDate: format(getToDate, "dd-MM-yyyy"),
                    }));
                  }}
                />
                <CommonButton
                  type="button"
                  label="Reset"
                  className="border border-customRed text-customRed"
                />
              </div>

              <div className="flex justify-end col-span-1 sm:col-span-2 xl:col-span-1">
                <CommonButton
                  type="button"
                  label={
                    selectedScreen === "Transfer"
                      ? "Previous Transfer List"
                      : "Previous Receive List"
                  }
                  className="bg-customBlue text-white"
                  onClick={() => setOpenPreviousListModal(true)}
                />
              </div>

            </div>
          )}
      </div>

      {/* <div className="grid lg:grid-cols-2 justify-between">
        <div className="flex space-x-2 items-center mt-3">
          <fieldset className="hidden">
            <RadioField
              control={control}
              name="itemType"
              dataArray={itemType}
            />
          </fieldset>
          {getItemType === "Kit" ? (
            <div className="w-80">
              <SearchDropdown
                control={control}
                searchIcon={true}
                name="itemKit"
                dataArray={itemKitOptions}
                isSearchable={true}
                placeholder="Search Item Kit"
                isClearable={true}
              // handleInputChange={handleItemKitChange}
              />
            </div>
          ) : (
            <div className="w-80">
              <SearchDropdown
                control={control}
                searchIcon={true}
                name="itemKit"
                // dataArray={itemKitOptions}
                isSearchable={true}
                placeholder="Search Item Name"
                isClearable={true}
              // handleInputChange={handleItemKitChange}
              />
            </div>
          )}
          <CommonButton
            type="button"
            searchIcon={true}
            className="bg-customBlue text-white"
          />
        </div>
        <div className="">
          {transferReceiveKitItemsList?.length > 0 && (
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={values}
                onChange={handleChange}
                aria-label="basic tabs example"
                variant="scrollable"
              >
                {transferReceiveKitItemsList?.map((val, ind) => (
                  <Tab label={val?.kitName} {...a11yProps(ind)} />
                ))}
              </Tabs>
            </Box>
          )}
        </div>
      </div> */}


      {
        getItemType === "Kit" ? (
          <div className="grid xl:grid-cols-2 xl:gap-x-2">
            {/* {transferReceiveKitList?.length > 0 ? (
              <CommonTransactionTable
                dataResult={transferReceiveKitList}
                page={kitPage}
                setPage={setKitPage}
                count={kitCount}
                rowsPerPage={kitRowsPerPage}
                renderInput={renderInputKit}
                populateTable={populateKitTable}
                editableColumns={["Select"]}
                highlightRow={false}
                tableClass={"h-96"}
                onChange={() => handleCheckboxChange(row, index)}
                removeHeaders={[
                  "Sr No",
                  "Id",
                  "Created Date",
                  "Last Modified Date",
                  "Created By",
                  "Last Modified By",
                  "Item Id",
                  "Item Code",
                  "Item Name",
                  "Ot Details Id",
                  "Receive Date",
                  "Status",
                  "Transfer Date",
                  "Received By",
                  "Sent By",
                  "Cleaned Qty",
                  "Cleaning Status",
                  "Decontamination Status",
                  "Receive Qty",
                  "Sterilization Qty",
                  "Sterilization Status",
                  "Transfer Qty",
                  "Wrapped Qty",
                  "Wrapping Status",
                  "Cleaned By",
                  "Wrapped By",
                  "Sterilized By",
                  "Receive Status",
                  "Sterilization Status Type",
                  "Transfer Status",
                  "Sterilization End By",
                  "Sterilization Start By",
                  "Transferred By",
                  "Used Quantity",
                  "Sterilization ExpiryDate",
                  "AddToStock Qty",
                  "Cleaning Start Date",
                  "Cleaning End Date",
                  "Wrapping Start Date",
                  "Wrapping End Date",
                  "Sterilization Equipment Id",
                  "Machine Id",
                  "Machine Name",
                  "Sterilization Start Date",
                  "Sterilization End Date",
                  "Sterilization Equipment",
                  "Sterilization Method Id",
                  "Sterilization Method",
                  "Wrapper Type Id",
                  "Wrapper Type",
                  "Wrapping Method Id",
                  "Wrapping Method",
                  "Issue Date",
                  "Issue Qty",
                  "Issue Status",
                  "Issued By",
                  "Disposed Date",
                  "Disposed Qty",
                  "Disposed By",
                  "Disposed Reason",
                  "Item BatchNo",
                  "Temperature",
                  "Pressure",
                  "Cssd Transfer Id",
                ]}
              />
            ) : (
              <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                No Records Found...
              </div>
            )} */}

            {/* Indent Requests Screen start */}
            {selectedScreen === "Transfer" && (
              transferCSSDList?.length > 0 ? (
                <CommonTransactionTable
                  dataResult={transferCSSDList}
                  page={page}
                  setPage={setPage}
                  count={transferCSSDList.length}
                  rowsPerPage={rowsPerPage}
                  renderInput={renderInputTransferkit}
                  populateTable={populateTransferTable}
                  onSelectClick={(row) => handleSelectClick(row)}
                  editableColumns={["Select"]}
                  highlightRow={false}
                  tableClass={"h-96"}
                  removeHeaders={[
                    "indent_id",
                    // "id",
                    "Sr No",
                    "Id",
                    "Created Date",
                    "Last Modified Date",
                    "Created By",
                    "Last Modified By",
                    // "Item Id",
                    "Item Code",
                    "Item Name",
                    "Ot Details Id",
                    "Receive Date",
                    "Status",
                    "Transfer Date",
                    "Received By",
                    "Sent By",
                    "Cleaned Qty",
                    "Cleaning Status",
                    "Decontamination Status",
                    "Receive Qty",
                    "Sterilization Qty",
                    "Sterilization Status",
                    "Transfer Qty",
                    "Wrapped Qty",
                    "Wrapping Status",
                    "Cleaned By",
                    "Wrapped By",
                    "Sterilized By",
                    "Receive Status",
                    "Sterilization Status Type",
                    "Transfer Status",
                    "Sterilization End By",
                    "Sterilization Start By",
                    "Transferred By",
                    "Used Quantity",
                    "Sterilization ExpiryDate",
                    "AddToStock Qty",
                    "Cleaning Start Date",
                    "Cleaning End Date",
                    "Wrapping Start Date",
                    "Wrapping End Date",
                    "Sterilization Equipment Id",
                    "Machine Id",
                    "Machine Name",
                    "Sterilization Start Date",
                    "Sterilization End Date",
                    "Sterilization Equipment",
                    "Sterilization Method Id",
                    "Sterilization Method",
                    "Wrapper Type Id",
                    "Wrapper Type",
                    "Wrapping Method Id",
                    "Wrapping Method",
                    "Issue Date",
                    "Issue Qty",
                    "Issue Status",
                    "Issued By",
                    "Disposed Date",
                    "Disposed Qty",
                    "Disposed By",
                    "Disposed Reason",
                    "Item BatchNo",
                    "Temperature",
                    "Pressure",
                    "Cssd Transfer Id",
                  ]}
                />
              ) : (
                <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                  No Records Found...
                </div>
              )
            )}

            {selectedScreen === "Transfer" && (
              Array.isArray(transferReceiveItemsList) && transferReceiveItemsList.length > 0 ? (
                <div className="mt-4">
                  {(() => {
                    const kitMap = new Map();
                    transferReceiveItemsList.forEach(item => {
                      if (!kitMap.has(item.kitId)) {
                        kitMap.set(item.kitId, item.KitName || `Kit ${item.kitId}`);
                      }
                    });

                    if (values === null && kitMap.size > 0) {
                      setValues([...kitMap.keys()][0]);
                    }

                    return (
                      <div className="flex space-x-4 border-b border-gray-300">
                        {Array.from(kitMap.entries()).map(([kitId, kitName]) => (
                          <button
                            key={kitId}
                            className={`px-3 py-1 font-semibold ${Number(values) === Number(kitId)
                              ? "text-customBlue border-b-2 border-customBlue"
                              : "text-gray-500"
                              }`}
                            onClick={() => {
                              setValues(Number(kitId));
                              setSelectedBatchNo("");
                            }}
                          >
                            {kitName}
                          </button>
                        ))}
                      </div>
                    );
                  })()}

                  {(() => {
                    const itemsForKit = transferReceiveItemsList.filter(
                      item => Number(item.kitId) === Number(values)
                    );

                    if (itemsForKit.length === 0) {
                      return (
                        <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                          No Records Found...
                        </div>
                      );
                    }

                    // Update helper
                    const updateItemInFlatList = (rowMatcher, changes) => {
                      setTransferReceiveItemsList(prev =>
                        prev.map(it => (rowMatcher(it) ? { ...it, ...changes } : it))
                      );
                    };

                    // 🔹 Editable Batch No column
                    const renderInputTransferkitItem = (row, index, header) => {
                      if (header === "Select") {
                        return (
                          <Checkbox
                            size="small"
                            checked={!!row?.Select}
                            onChange={() => {
                              updateItemInFlatList(
                                it =>
                                  Number(it.kitId) === Number(row.kitId) &&
                                  Number(it.itemId) === Number(row.itemId),
                                { Select: !row?.Select }
                              );
                            }}
                          />
                        );
                      }

                      if (header === "Batch No") {
                        return (
                          <TextField
                            value={row?.batchNo || ""}
                            placeholder="Enter Batch No"
                            size="small"
                            onChange={(e) => {
                              const value = e.target.value;
                              updateItemInFlatList(
                                it =>
                                  Number(it.kitId) === Number(row.kitId) &&
                                  Number(it.itemId) === Number(row.itemId),
                                { batchNo: value }
                              );
                            }}
                            sx={{
                              width: 180,
                              "& .MuiInputBase-root": { height: 28 },
                              "& .MuiInputBase-input": {
                                padding: "2px 6px",
                                fontSize: "0.85rem",
                              },
                            }}
                          />
                        );
                      }

                      return row?.[header];
                    };

                    return (
                      <div className="mt-2">
                        {/* 🔹 Top Batch No input to apply to all rows */}
                        <div className="flex flex-col space-y-2 bg-[#F1F1F1] p-2 rounded-md">
                          <div className="flex justify-between font-semibold text-sm">
                            <label>{itemsForKit[0]?.KitName || `Kit ${itemsForKit[0]?.kitId}`}</label>

                            <div className="flex items-center space-x-2">
                              <label className="text-sm font-medium">Batch No.</label>
                              <Autocomplete
                                freeSolo
                                size="small"
                                loading={loading}
                                options={batchOptions}
                                value={selectedBatchNo || ""}
                                onInputChange={(e, newValue, reason) => {
                                  setSelectedBatchNo(newValue);
                                  if (reason === "input") handleSearch(newValue);
                                }}
                                onChange={(e, newValue) => {
                                  setSelectedBatchNo(newValue);
                                  // ✅ Update all items for selected kit
                                  setTransferReceiveItemsList(prev =>
                                    prev.map(item =>
                                      Number(item.kitId) === Number(values)
                                        ? { ...item, batchNo: newValue }
                                        : item
                                    )
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Search Batch No"
                                    size="small"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <SearchIcon fontSize="small" />
                                        </InputAdornment>
                                      ),
                                    }}
                                    sx={{
                                      width: 210,
                                      "& .MuiInputBase-root": { height: 30 },
                                      "& .MuiInputBase-input": { padding: "2px 6px", fontSize: "0.85rem" },
                                    }}
                                  />
                                )}
                              />
                            </div>

                            <label>Items Qty: {itemsForKit.length}</label>
                          </div>
                        </div>

                        <CommonTransactionTable
                          dataResult={itemsForKit}
                          tableClass="-mt-1 h-96 text-[9px] leading-tight [&_tr]:!h-[5px] [&_td]:!py-[1px] [&_th]:!py-[1px] [&_td]:!h-[5px]"
                          renderInput={(row, index, header) =>
                            renderInputTransferkitItem(row, index, header)
                          }
                          editableColumns={["Select", "Batch No"]}
                          highlightRow={false}
                          removeHeaders={[
                            "Sr No",
                            "Used Quantity",
                            "Transfer Qty",
                            "Transfer Date",
                            "Receive Date",
                            "Transferred By",
                            "Received By",
                            "Ot Details Id",
                            "Item Id",
                            "Created Date",
                            "Last Modified Date",
                            "Cleaned Qty",
                            "Cleaning Status",
                            "Decontamination Status",
                            "Sterilization Qty",
                            "Sterilization Status",
                            "Wrapped Qty",
                            "Wrapping Status",
                            "Cleaned By",
                            "Wrapped By",
                            "Sterilized By",
                            "Receive Status",
                            "Sterilization Status Type",
                            "Transfer Status",
                            "Sterilization End By",
                            "Sterilization Start By",
                            "Transferred By",
                            "id",
                            "Created By",
                            "Last Modified By",
                            "Status",
                            "Sent By",
                            "Item Kit Code",
                            "Sterilization Equipment",
                            "Sterilization Equipment Id",
                            "Sterilization Method",
                            "Sterilization Method Id",
                            "Sterilization ExpiryDate",
                            "AddToStock Qty",
                            "Wrapper Type Id",
                            "Wrapper Type",
                            "Wrapping Method Id",
                            "Wrapping Method",
                            "Sterilization End Date",
                            "Sterilization Start Date",
                            "Kit BatchNo",
                            "Cssd Transfer Id",
                          ]}
                        />
                      </div>
                    );
                  })()}
                </div>
              ) : (
                <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                  No Records Found...
                </div>
              )
            )}
            {/* Indent Requests Screen end */}


            {/* CSSD Kit Request Screen Start */}
            {selectedScreen !== "Transfer" && selectedScreen !== "Receive" && selectedScreen !== "ReceiveCSSD" && selectedScreen !== "TransferOT" && (
              transferReceiveKitList?.length > 0 ? (
                <CommonTransactionTable
                  dataResult={transferReceiveKitList}
                  page={kitPage}
                  setPage={setKitPage}
                  count={kitCount}
                  rowsPerPage={kitRowsPerPage}
                  renderInput={renderInputKit}
                  populateTable={populateTransferTableindent}
                  editableColumns={["Select"]}
                  highlightRow={false}
                  tableClass={"h-96"}
                  removeHeaders={[
                    "id",
                    "Sr No",
                    "kitBatchNo",
                    // "kitBatchNo",
                    // "Id",
                    "Created Date",
                    "Last Modified Date",
                    "Created By",
                    "Last Modified By",
                    "Item Id",
                    "Item Code",
                    "Item Name",
                    "Ot Details Id",
                    "Receive Date",
                    "Status",
                    "Transfer Date",
                    "Received By",
                    "Sent By",
                    "Cleaned Qty",
                    "Cleaning Status",
                    "Decontamination Status",
                    "Receive Qty",
                    "Sterilization Qty",
                    "Sterilization Status",
                    "Transfer Qty",
                    "Wrapped Qty",
                    "Wrapping Status",
                    "Cleaned By",
                    "Wrapped By",
                    "Sterilized By",
                    "Receive Status",
                    "Sterilization Status Type",
                    "Transfer Status",
                    "Sterilization End By",
                    "Sterilization Start By",
                    "Transferred By",
                    "Used Quantity",
                    "Sterilization ExpiryDate",
                    "AddToStock Qty",
                    "Cleaning Start Date",
                    "Cleaning End Date",
                    "Wrapping Start Date",
                    "Wrapping End Date",
                    "Sterilization Equipment Id",
                    "Machine Id",
                    "Machine Name",
                    "Sterilization Start Date",
                    "Sterilization End Date",
                    "Sterilization Equipment",
                    "Sterilization Method Id",
                    "Sterilization Method",
                    "Wrapper Type Id",
                    "Wrapper Type",
                    "Wrapping Method Id",
                    "Wrapping Method",
                    "Issue Date",
                    "Issue Qty",
                    "Issue Status",
                    "Issued By",
                    "Disposed Date",
                    "Disposed Qty",
                    "Disposed By",
                    "Disposed Reason",
                    "Item BatchNo",
                    "Temperature",
                    "Pressure",
                    "Cssd Transfer Id",
                  ]}
                />
              ) : (
                <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                  No Records Found...
                </div>
              )
            )}

            {selectedScreen !== "Transfer" && selectedScreen !== "Receive" && selectedScreen !== "ReceiveCSSD" && selectedScreen !== "TransferOT" && (
              transferReceiveKitItemsList.length > 0 ? (
                <div className="mt-4">
                  <div className="flex space-x-4 border-b border-gray-300">
                    {transferReceiveKitItemsList.map((kit) => (
                      <button
                        key={kit.id}
                        className={`px-3 py-1 font-semibold ${values === kit.id
                          ? "text-customBlue border-b-2 border-customBlue"
                          : "text-gray-500"
                          }`}
                        onClick={() => setValues(kit.id)}
                      >
                        {kit.KitName}
                      </button>
                    ))}
                  </div>

                  {transferReceiveKitItemsList.length > 0 && !values && (
                    setValues(transferReceiveKitItemsList[transferReceiveKitItemsList.length - 1].id)
                  )}

                  {transferReceiveKitItemsList.map((kit) =>
                    kit.id === values ? (
                      <div key={kit.id} className="mt-2">
                        <div className="flex justify-between font-semibold text-sm bg-[#F1F1F1] px-2 py-1">
                          <label>{kit.KitName}</label>
                          <label>Items Qty : {kit.kitItemList?.length}</label>
                        </div>

                        <CommonTransactionTable
                          dataResult={kit.kitItemList}
                          tableClass="-mt-1 h-96"
                          renderInput={renderInputKitItem}
                          editableColumns={[
                            "Quantity",
                            "IssueQty",
                            "Select",
                            selectedScreen === "Transfer" ? "Issue Qty" : "Receive Qty",
                            "Disposed Qty",
                            "Disposed Reason",
                          ]}
                          highlightRow={false}
                          removeHeaders={[
                            "qty",

                            "Sr No",
                            "Used Quantity",
                            "Transfer Qty",
                            "Transfer Date",
                            "Receive Date",
                            "Transferred By",
                            "Received By",
                            "Ot Details Id",
                            "Item Id",
                            "Created Date",
                            "Last Modified Date",
                            "Cleaned Qty",
                            "Cleaning Status",
                            "Decontamination Status",
                            "Sterilization Qty",
                            "Sterilization Status",
                            "Wrapped Qty",
                            "Wrapping Status",
                            "Cleaned By",
                            "Wrapped By",
                            "Sterilized By",
                            "Receive Status",
                            "Sterilization Status Type",
                            "Transfer Status",
                            "Sterilization End By",
                            "Sterilization Start By",
                            "Transferred By",
                            "Id",
                            "Created Date",
                            "Created By",
                            "Last Modified By",
                            "Status",
                            "Sent By",
                            "Item Kit Code",
                            "Sterilization Equipment",
                            "Sterilization Equipment Id",
                            "Sterilization Method",
                            "Sterilization Method Id",
                            "Sterilization ExpiryDate",
                            "AddToStock Qty",
                            "Wrapper Type Id",
                            "Wrapper Type",
                            "Wrapping Method Id",
                            "Wrapping Method",
                            "Sterilization End Date",
                            "Sterilization Start Date",
                            selectedScreen === "Transfer" && "Receive Qty",
                            selectedScreen === "Receive" && "Issue Qty",
                            "Wrapping Start Date",
                            "Wrapping End Date",
                            "Cleaning Start Date",
                            "Cleaning End Date",
                            "Machine Id",
                            "Machine Name",
                            "Issue Date",
                            "Issue Status",
                            "Issued By",
                            "Disposed Date",
                            "Disposed By",
                            "Item Kit Name",
                            "Old Issue Qty",
                            "Old Receive Qty",
                            "Kit BatchNo",
                            "Temperature",
                            "Pressure",
                            "Cssd Transfer Id",
                          ]}
                        />
                      </div>
                    ) : null
                  )}
                </div>
              ) : (
                <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                  No Records Found...
                </div>
              )
            )}
            {/* CSSD Kit Request Screen end */}


            {/* OT -> Receive CSSD Items Screen Start */}
            {selectedScreen === "Receive" && (
              transferReceiveKitList?.length > 0 ? (
                <CommonTransactionTable
                  dataResult={transferReceiveKitList}
                  page={kitPage}
                  setPage={setKitPage}
                  count={kitCount}
                  rowsPerPage={kitRowsPerPage}
                  renderInput={renderInputKitReceive}
                  populateTable={populateKitTable}
                  editableColumns={["Select"]}
                  highlightRow={false}
                  tableClass={"h-96"}
                  removeHeaders={[
                    // "id",
                    "Sr No",
                    "kitBatchNo",
                    // "kitBatchNo"
                    "Id",
                    "Created Date",
                    "Last Modified Date",
                    "Created By",
                    "Last Modified By",
                    "Item Id",
                    "Item Code",
                    "Item Name",
                    "Ot Details Id",
                    "Receive Date",
                    "Status",
                    "Transfer Date",
                    "Received By",
                    "Sent By",
                    "Cleaned Qty",
                    "Cleaning Status",
                    "Decontamination Status",
                    "Receive Qty",
                    "Sterilization Qty",
                    "Sterilization Status",
                    "Transfer Qty",
                    "Wrapped Qty",
                    "Wrapping Status",
                    "Cleaned By",
                    "Wrapped By",
                    "Sterilized By",
                    "Receive Status",
                    "Sterilization Status Type",
                    "Transfer Status",
                    "Sterilization End By",
                    "Sterilization Start By",
                    "Transferred By",
                    "Used Quantity",
                    "Sterilization ExpiryDate",
                    "AddToStock Qty",
                    "Cleaning Start Date",
                    "Cleaning End Date",
                    "Wrapping Start Date",
                    "Wrapping End Date",
                    "Sterilization Equipment Id",
                    "Machine Id",
                    "Machine Name",
                    "Sterilization Start Date",
                    "Sterilization End Date",
                    "Sterilization Equipment",
                    "Sterilization Method Id",
                    "Sterilization Method",
                    "Wrapper Type Id",
                    "Wrapper Type",
                    "Wrapping Method Id",
                    "Wrapping Method",
                    "Issue Date",
                    "Issue Qty",
                    "Issue Status",
                    "Issued By",
                    "Disposed Date",
                    "Disposed Qty",
                    "Disposed By",
                    "Disposed Reason",
                    "Item BatchNo",
                    "Temperature",
                    "Pressure",
                    "Cssd Transfer Id",
                  ]}
                />
              ) : (
                <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                  No Records Found...
                </div>
              )
            )}

            {selectedScreen === "Receive" && (
              finalTabs.length > 0 ? (
                <div className="mt-4">

                  <div className="flex space-x-4 border-b border-gray-300">
                    {finalTabs.map((tab, index) => (
                      <button
                        key={index}
                        className={`px-3 py-1 font-semibold ${values === index
                          ? "text-customBlue border-b-2 border-customBlue"
                          : "text-gray-500"
                          }`}
                        onClick={() => setValues(index)}
                      >
                        {tab.KitName || `Kit ${tab.kitId}`}
                      </button>
                    ))}
                  </div>

                  {finalTabs.map((tab, index) =>
                    index === values ? (
                      <div key={index} className="mt-2">

                        <div className="flex justify-between font-semibold text-sm bg-[#F1F1F1] px-2 py-1">
                          <label>{`Kit ${tab.kitId}`}</label>
                          <label>Items Qty : {tab.items.length}</label>
                        </div>

                        <CommonTransactionTable
                          dataResult={tab.items}
                          tableClass="-mt-1 h-96"
                          renderInput={renderReceiveKitItem}
                          editableColumns={[
                            "Quantity",
                            "IssueQty",
                            "Select",
                            "Receive Qty",
                            "Disposed Qty",
                            "Disposed Reason",
                          ]}
                          highlightRow={false}
                          removeHeaders={[
                            // "id",
                            "Sr No",
                            "kitBatchNo",
                            // "kitBatchNo"
                            "Id",
                            "Created Date",
                            "Last Modified Date",
                            "Created By",
                            "Last Modified By",
                            "Item Id",
                            "Item Code",
                            "Item Name",
                            "Ot Details Id",
                            "Receive Date",
                            "Status",
                            "Transfer Date",
                            "Received By",
                            "Sent By",
                            "Cleaned Qty",
                            "Cleaning Status",
                            "Decontamination Status",
                            "Receive Qty",
                            "Sterilization Qty",
                            "Sterilization Status",
                            "Transfer Qty",
                            "Wrapped Qty",
                            "Wrapping Status",
                            "Cleaned By",
                            "Wrapped By",
                            "Sterilized By",
                            "Receive Status",
                            "Sterilization Status Type",
                            "Transfer Status",
                            "Sterilization End By",
                            "Sterilization Start By",
                            "Transferred By",
                            "Used Quantity",
                            "Sterilization ExpiryDate",
                            "AddToStock Qty",
                            "Cleaning Start Date",
                            "Cleaning End Date",
                            "Wrapping Start Date",
                            "Wrapping End Date",
                            "Sterilization Equipment Id",
                            "Machine Id",
                            "Machine Name",
                            "Sterilization Start Date",
                            "Sterilization End Date",
                            "Sterilization Equipment",
                            "Sterilization Method Id",
                            "Sterilization Method",
                            "Wrapper Type Id",
                            "Wrapper Type",
                            "Wrapping Method Id",
                            "Wrapping Method",
                            "Issue Date",
                            "Issue Qty",
                            "Issue Status",
                            "Issued By",
                            "Disposed Date",
                            "Disposed Qty",
                            "Disposed By",
                            "Disposed Reason",
                            "Item BatchNo",
                            "Temperature",
                            "Pressure",
                            "Cssd Transfer Id",
                          ]}
                        />

                      </div>
                    ) : null
                  )}

                </div>
              ) : (
                <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                  No Records Found...
                </div>
              )
            )}
            {/* OT -> Receive CSSD Items Screen end */}

            {/* OT -> TransferCSSD Items Screen Start */}
            {selectedScreen === "TransferOT" && (
              transferReceiveKitList?.length > 0 ? (
                <CommonTransactionTable
                  dataResult={transferReceiveKitList}
                  page={kitPage}
                  setPage={setKitPage}
                  count={kitCount}
                  rowsPerPage={kitRowsPerPage}
                  renderInput={renderInputKitTransferOTs}
                  populateTable={populateKitItemTableTransferOT}
                  editableColumns={["Select"]}
                  highlightRow={false}
                  tableClass={"h-96"}
                  removeHeaders={[
                    "id",
                    "Sr No",
                    // "Id",
                    "Created Date",
                    "Last Modified Date",
                    "Created By",
                    "Last Modified By",
                    "Item Id",
                    "Item Code",
                    "Item Name",
                    "Ot Details Id",
                    "Receive Date",
                    "Status",
                    "Transfer Date",
                    "Received By",
                    "Sent By",
                    "Cleaned Qty",
                    "Cleaning Status",
                    "Decontamination Status",
                    "Receive Qty",
                    "Sterilization Qty",
                    "Sterilization Status",
                    "Transfer Qty",
                    "Wrapped Qty",
                    "Wrapping Status",
                    "Cleaned By",
                    "Wrapped By",
                    "Sterilized By",
                    "Receive Status",
                    "Sterilization Status Type",
                    "Transfer Status",
                    "Sterilization End By",
                    "Sterilization Start By",
                    "Transferred By",
                    "Used Quantity",
                    "Sterilization ExpiryDate",
                    "AddToStock Qty",
                    "Cleaning Start Date",
                    "Cleaning End Date",
                    "Wrapping Start Date",
                    "Wrapping End Date",
                    "Sterilization Equipment Id",
                    "Machine Id",
                    "Machine Name",
                    "Sterilization Start Date",
                    "Sterilization End Date",
                    "Sterilization Equipment",
                    "Sterilization Method Id",
                    "Sterilization Method",
                    "Wrapper Type Id",
                    "Wrapper Type",
                    "Wrapping Method Id",
                    "Wrapping Method",
                    "Issue Date",
                    "Issue Qty",
                    "Issue Status",
                    "Issued By",
                    "Disposed Date",
                    "Disposed Qty",
                    "Disposed By",
                    "Disposed Reason",
                    "Item BatchNo",
                    "Temperature",
                    "Pressure",
                    "Cssd Transfer Id",
                  ]}
                />
              ) : (
                <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                  No Records Found...
                </div>
              )
            )}

            {selectedScreen === "TransferOT" && (
              transferReceiveKitItemsList.length > 0 ? (
                <div className="mt-4">
                  <div className="flex space-x-4 border-b border-gray-300">
                    {transferReceiveKitItemsList.map((kit) => (
                      <button
                        key={kit.id}
                        className={`px-3 py-1 font-semibold ${values === kit.id
                          ? "text-customBlue border-b-2 border-customBlue"
                          : "text-gray-500"
                          }`}
                        onClick={() => setValues(kit.id)}
                      >
                        {kit.KitName}
                      </button>
                    ))}
                  </div>

                  {transferReceiveKitItemsList.length > 0 && !values && (
                    setValues(transferReceiveKitItemsList[transferReceiveKitItemsList.length - 1].id)
                  )}

                  {transferReceiveKitItemsList.map((kit) =>
                    kit.id === values ? (
                      <div key={kit.id} className="mt-2">
                        <div className="flex justify-between font-semibold text-sm bg-[#F1F1F1] px-2 py-1">
                          <label>{kit.KitName}</label>
                          <label>Items Qty : {kit.kitItemList?.length}</label>
                        </div>

                        <CommonTransactionTable
                          dataResult={kit.kitItemList}
                          tableClass="-mt-1 h-96"
                          renderInput={renderInputKitItemTransferOT}
                          editableColumns={[
                            "Quantity",
                            "IssueQty",
                            "Select",
                            selectedScreen === "Transfer" ? "Issue Qty" : "Receive Qty",
                            "Disposed Qty",
                            "Disposed Reason",
                          ]}
                          highlightRow={false}
                          removeHeaders={[
                            "Sr No",
                            "qty",
                            "itemId",
                            // "Quantity",
                            "Used Quantity",
                            "Transfer Qty",
                            "Transfer Date",
                            "Receive Date",
                            "Transferred By",
                            "Received By",
                            "Ot Details Id",
                            // "Item Id",
                            "Created Date",
                            "Last Modified Date",
                            "Cleaned Qty",
                            "Cleaning Status",
                            "Decontamination Status",
                            "Sterilization Qty",
                            "Sterilization Status",
                            "Wrapped Qty",
                            "Wrapping Status",
                            "Cleaned By",
                            "Wrapped By",
                            "Sterilized By",
                            "Receive Status",
                            "Sterilization Status Type",
                            "Transfer Status",
                            "Sterilization End By",
                            "Sterilization Start By",
                            "Transferred By",
                            "Id",
                            "Created Date",
                            "Created By",
                            "Last Modified By",
                            "Status",
                            "Sent By",
                            "Item Kit Code",
                            "Sterilization Equipment",
                            "Sterilization Equipment Id",
                            "Sterilization Method",
                            "Sterilization Method Id",
                            "Sterilization ExpiryDate",
                            "AddToStock Qty",
                            "Wrapper Type Id",
                            "Wrapper Type",
                            "Wrapping Method Id",
                            "Wrapping Method",
                            "Sterilization End Date",
                            "Sterilization Start Date",
                            selectedScreen === "Transfer" && "Receive Qty",
                            selectedScreen === "Receive" && "Issue Qty",
                            "Wrapping Start Date",
                            "Wrapping End Date",
                            "Cleaning Start Date",
                            "Cleaning End Date",
                            "Machine Id",
                            "Machine Name",
                            "Issue Date",
                            "Issue Status",
                            "Issued By",
                            "Disposed Date",
                            "Disposed By",
                            "Item Kit Name",
                            "Old Issue Qty",
                            "Old Receive Qty",
                            "Kit BatchNo",
                            "Temperature",
                            "Pressure",
                            "Cssd Transfer Id",
                          ]}
                        />
                      </div>
                    ) : null
                  )}
                </div>
              ) : (
                <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                  No Records Found...
                </div>
              )
            )}
            {/* OT -> TransferCSSD Items Screen End */}


            {/* CSSD Receive CSSD Items Screen start */}
            {selectedScreen === "ReceiveCSSD" && (
              <div className="w-full">
                {receiveCssdList?.length > 0 ? (
                  <CommonTransactionTable
                    dataResult={(receiveCssdList || []).map((row) => ({
                      Select: row?.Select || false, // safe check
                      ...row,
                    }))}
                    page={kitPage}
                    setPage={setKitPage}
                    count={kitCount}
                    rowsPerPage={kitRowsPerPage}
                    renderInput={renderInputKitTransferOT}
                    populateTable={populateKitTable}
                    editableColumns={["Select"]}
                    highlightRow={false}
                    tableClass={"h-96"}
                    removeHeaders={[
                      "Id",
                      "createdBy",
                      "cssdLotNo",
                      "Sr No",
                      "Created Date",
                      "from_store_id",
                      "unit_id",
                      // "unit_id",
                      // "from_store_id",
                      "to_store_id",
                      // "to_store_id",
                      "discardedQuantity",
                      // "discardedQuantity",
                      "transitQuantity",
                      // "transitQuantity",
                      "lastModifiedBy",
                      // "Last Modified Date",
                      // "cssdLotNo",
                      // "Created By",
                      "ot_details_id",
                      // "ot_details_id",
                      "Last Modified By",
                      "Item Id",
                      "Item Code",
                      "Item Name",
                      "Ot Details Id",
                      "Receive Date",
                      "Status",
                      "transferDate",
                      // "Transfer Date",
                      "Received By",
                      "Sent By",
                      "Cleaned Qty",
                      "Cleaning Status",
                      "Decontamination Status",
                      "Receive Qty",
                      "Sterilization Qty",
                      "Sterilization Status",
                      "transferQty",
                      // "Transfer Qty",
                      "Wrapped Qty",
                      "Wrapping Status",
                      "Cleaned By",
                      "Wrapped By",
                      "Sterilized By",
                      "Receive Status",
                      "Sterilization Status Type",
                      "transferStatus",
                      // "Transfer Status",
                      "Sterilization End By",
                      "Sterilization Start By",
                      "transferred_by",
                      // "Transferred By",
                      "Used Quantity",
                      "Sterilization ExpiryDate",
                      "AddToStock Qty",
                      "Cleaning Start Date",
                      "Cleaning End Date",
                      "Wrapping Start Date",
                      "Wrapping End Date",
                      "Sterilization Equipment Id",
                      "Machine Id",
                      "Machine Name",
                      "Sterilization Start Date",
                      "Sterilization End Date",
                      "Sterilization Equipment",
                      "Sterilization Method Id",
                      "Sterilization Method",
                      "Wrapper Type Id",
                      "Wrapper Type",
                      "Wrapping Method Id",
                      "Wrapping Method",
                      "Issue Date",
                      "issuedQuantity",
                      // "Issue Qty",
                      "Issue Status",
                      "Issued By",
                      "Disposed Date",
                      "Disposed Qty",
                      "Disposed By",
                      "Disposed Reason",
                      "Item BatchNo",
                      "Temperature",
                      "Pressure",
                      "Cssd Transfer Id",
                    ]}
                  />
                ) : (
                  <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                    No Records Found...
                  </div>
                )}
              </div>
            )}

            {selectedScreen === "ReceiveCSSD" && (
              finalTabs.length > 0 ? (
                <div className="mt-4">
                  <div className="flex space-x-4 border-b border-gray-300">
                    {finalTabs.map((tab, index) => (
                      <button
                        key={index}
                        className={`px-3 py-1 font-semibold ${values === index
                          ? "text-customBlue border-b-2 border-customBlue"
                          : "text-gray-500"
                          }`}
                        onClick={() => setValues(index)}
                      >
                        {tab.KitName || `Kit ${tab.kitId}`}
                      </button>
                    ))}
                  </div>

                  {finalTabs.map((tab, index) =>
                    index === values ? (
                      <div key={index} className="mt-2">

                        <div className="flex justify-between font-semibold text-sm bg-[#F1F1F1] px-2 py-1">
                          <label>{tab.KitName || `Kit ${tab.kitId}`}</label>
                          <label>Items Qty : {tab.items?.length}</label>
                        </div>

                        <CommonTransactionTable
                          dataResult={tab.items}
                          tableClass="-mt-1 h-96"
                          renderInput={renderInputTransferkitItem}
                          editableColumns={[
                            "Quantity",
                            "IssueQty",
                            "Select",
                            selectedScreen === "Transfer" ? "Issue Qty" : "Receive Qty",
                            "Disposed Qty",
                            "Disposed Reason",
                          ]}
                          highlightRow={false}
                          removeHeaders={[
                            "Sr No",
                            "Used Quantity",
                            "Transfer Qty",
                            "Transfer Date",
                            "Receive Date",
                            "Transferred By",
                            "Received By",
                            "Ot Details Id",
                            "Item Id",
                            "Created Date",
                            "Last Modified Date",
                            "Cleaned Qty",
                            "Cleaning Status",
                            "Decontamination Status",
                            "Sterilization Qty",
                            "Sterilization Status",
                            "Wrapped Qty",
                            "Wrapping Status",
                            "Cleaned By",
                            "Wrapped By",
                            "Sterilized By",
                            "Receive Status",
                            "Sterilization Status Type",
                            "Transfer Status",
                            "Sterilization End By",
                            "Sterilization Start By",
                            "Transferred By",
                            "id",
                            "Created By",
                            "Last Modified By",
                            "Status",
                            "Sent By",
                            "Item Kit Code",
                            "Sterilization Equipment",
                            "Sterilization Equipment Id",
                            "Sterilization Method",
                            "Sterilization Method Id",
                            "Sterilization ExpiryDate",
                            "AddToStock Qty",
                            "Wrapper Type Id",
                            "Wrapper Type",
                            "Wrapping Method Id",
                            "Wrapping Method",
                            "Sterilization End Date",
                            "Sterilization Start Date",
                            "Wrapping Start Date",
                            "Wrapping End Date",
                            "Cleaning Start Date",
                            "Cleaning End Date",
                            "Machine Id",
                            "Machine Name",
                            "Issue Date",
                            "Issue Status",
                            "Issued By",
                            "Disposed Date",
                            "Disposed By",
                            "Item BatchNo",
                            "Temperature",
                            "Pressure",
                            "Cssd Transfer Id",
                          ]}
                        />
                      </div>
                    ) : null
                  )}
                </div>
              ) : (
                <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                  No Records Found...
                </div>
              )
            )}
            {/* CSSD Receive CSSD Items Screen end */}


          </div>
        ) : (
          <div>
            {transferReceiveItemsList?.length > 0 ? (
              <CommonTransactionTable
                dataResult={transferReceiveItemsList}
                page={page}
                setPage={setPage}
                count={count}
                rowsPerPage={rowsPerPage}
                tableHeading={"Item List"}
                renderInput={renderInputItem}
                populateTable={populateItemTable}
                editableColumns={[
                  "Select",
                  selectedScreen === "Transfer" ? "Issue Qty" : "Receive Qty",
                  "Disposed Qty",
                  "Disposed Reason",
                ]}
                highlightRow={false}
                removeHeaders={[
                  "Sr No",
                  "Used Quantity",
                  "Transfer Qty",
                  "Transfer Date",
                  "Receive Date",
                  "Transferred By",
                  "Received By",
                  "Ot Details Id",
                  "Item Id",
                  "Created Date",
                  "Last Modified Date",
                  "Cleaned Qty",
                  "Cleaning Status",
                  "Decontamination Status",
                  "Sterilization Qty",
                  "Sterilization Status",
                  "Wrapped Qty",
                  "Wrapping Status",
                  "Cleaned By",
                  "Wrapped By",
                  "Sterilized By",
                  "Receive Status",
                  "Sterilization Status Type",
                  "Transfer Status",
                  "Sterilization End By",
                  "Sterilization Start By",
                  "Transferred By",
                  "Id",
                  "Created Date",
                  "Created By",
                  "Last Modified By",
                  "Status",
                  "Sent By",
                  "Item Kit Code",
                  "Sterilization Equipment",
                  "Sterilization Equipment Id",
                  "Sterilization Method",
                  "Sterilization Method Id",
                  "Sterilization ExpiryDate",
                  "AddToStock Qty",
                  "Wrapper Type Id",
                  "Wrapper Type",
                  "Wrapping Method Id",
                  "Wrapping Method",
                  "Sterilization End Date",
                  "Sterilization Start Date",
                  selectedScreen === "Transfer" && "Receive Qty",
                  selectedScreen === "Receive" && "Issue Qty",
                  "Wrapping Start Date",
                  "Wrapping End Date",
                  "Cleaning Start Date",
                  "Cleaning End Date",
                  "Machine Id",
                  "Machine Name",
                  "Issue Date",
                  "Issue Status",
                  "Issued By",
                  "Disposed Date",
                  "Disposed By",
                  "Item Kit Name",
                  "Old Issue Qty",
                  "Old Receive Qty",
                  "Kit BatchNo",
                  "Temperature",
                  "Pressure",
                  "Cssd Transfer Id",
                ]}
              />
            ) : (
              <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
                No Records Found...
              </div>
            )}
          </div>
        )
      }

      <div className="flex justify-end">
        {/* <CommonButton
          type="button"
          label={`${selectedScreen === "Transfer"
            ? "Transfer CSSD Items"
            : "Receive CSSD Items"
            }`}
          className="bg-customGreen text-white"
          onClick={() => {
            let itemDetailsArray =
              getItemType === "Item"
                ? transferReceiveItemsList?.filter(
                  (fil) => fil?.Select === true
                )
                : transferReceiveKitItemsList
                  ?.flatMap((val) => val?.kitItemList)
                  ?.filter((fil) => fil?.Select === true);
            if (getStore && itemDetailsArray?.length > 0) {
              setOpenPostModal(true);
              clearErrors("toStore");
            } else if (getStore === null) {
              setError("toStore", { type: "required", message: "Required" });
            } else if (itemDetailsArray?.length === 0) {
              // warningAlert("Select items to transfer or receive...!");
            }
          }}
        /> */}

        {/* <CommonButton
          type="button"
          label={
            selectedScreen === "Transfer"
              ? "Issue CSSD Items"
              : selectedScreen === "Receive"
                ? "Receive CSSD Items"
                : "Submit"
          }
          className="bg-customGreen text-white"
          onClick={() => {
            if (selectedScreen === "Transfer") {
              handleTransfer();
            } else if (selectedScreen === "Receive") {
              handleReceive();
            } else {
              handleSubmit();
            }
          }}
        /> */}

        <CommonButton
          type="button"
          label={
            selectedScreen === "Transfer"
              ? "Issue CSSD Items"
              : selectedScreen === "Receive"
                ? "Receive CSSD Items"
                : selectedScreen === "TransferOT"
                  ? "OT to CSSD Transfer"
                  : selectedScreen === "ReceiveCSSD"
                    ? "CSSD Received"
                    : "Submit"
          }
          className="bg-customGreen text-white"
          onClick={() => {
            if (selectedScreen === "Transfer") {
              handleTransfer();

            } else if (selectedScreen === "Receive") {
              handleReceive();

            } else if (selectedScreen === "TransferOT") {
              handleTransferOT();

            } else if (selectedScreen === "ReceiveCSSD") {
              handleReceiveCSSD();    // 👈 NEW FUNCTION

            } else {
              handleSubmit();
            }
          }}
        />

      </div>
      {/* {showConfirm && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/30">
          <div className="bg-white rounded-md p-6 w-[400px] shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Confirmation</h2>
            <p className="mb-6">Are you sure want to send CSSD Kit Request?</p>
            <div className="flex justify-end space-x-3">
              <button
                className="px-4 py-2 border border-red-500 text-red-500 rounded"
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-green-600 text-white rounded"
                onClick={confirmSubmit}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )} */}
      {/* {showConfirm && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/30">
          <div className="bg-white rounded-md p-6 w-[400px] shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Confirmation</h2>
            <p className="mb-6">
              {selectedScreen === "Transfer"
                ? "Are you sure you want to transfer these CSSD items?"
                : selectedScreen === "Receive"
                  ? "Are you sure you want to receive these CSSD items?"
                  : "Are you sure you want to send CSSD Kit Request?"}
            </p>
            <div className="flex justify-end space-x-3">
              <button
                className="px-4 py-2 border border-red-500 text-red-500 rounded"
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-green-600 text-white rounded"
                onClick={
                  selectedScreen === "Transfer"
                    ? confirmTransfer
                    : selectedScreen === "Receive"
                      ? confirmReceive
                      : selectedScreen === "TransferOT"
                        ? confirmTransferOT
                        : confirmSubmit
                }
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )} */}

      {showConfirm && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/30">
          <div className="bg-white rounded-md p-6 w-[400px] shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Confirmation</h2>

            <p className="mb-6">
              {selectedScreen === "Transfer"
                ? "Are you sure you want to transfer these CSSD items?"
                : selectedScreen === "Receive"
                  ? "Are you sure you want to receive these CSSD items?"
                  : selectedScreen === "TransferOT"
                    ? "Are you sure you want to submit this OT transfer?"
                    : selectedScreen === "ReceiveCSSD"
                      ? "Are you sure you want to receive CSSD items?"
                      : "Are you sure you want to send CSSD Kit Request?"}
            </p>

            <div className="flex justify-end space-x-3">
              <button
                className="px-4 py-2 border border-red-500 text-red-500 rounded"
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 bg-green-600 text-white rounded"
                onClick={
                  selectedScreen === "Transfer"
                    ? confirmTransfer
                    : selectedScreen === "Receive"
                      ? confirmReceive
                      : selectedScreen === "TransferOT"
                        ? confirmTransferOT
                        : selectedScreen === "ReceiveCSSD"
                          ? confirmReceiveCSSD        // ✅ NEW
                          : confirmSubmit
                }
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}


      <CommonBackDrop openBackdrop={openBackdrop} />
      {
        openPreviousListModal && (
          <IssueReceiveCSSDModal
            openPreviousListModal={openPreviousListModal}
            setOpenPreviousListModal={setOpenPreviousListModal}
            selectedScreen={selectedScreen}
          />
        )
      }
      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationSubmitFunc={addToStockList}
        confirmationLabel="Confirmation "
        confirmationMsg={
          selectedScreen === "Transfer"
            ? "Are you sure want to transfer this CSSD items ?"
            : "Are you sure want to receive this CSSD items ?"
        }
        confirmationButtonMsg="Confirm"
      />
    </div >
  );
};

export default TransferReceiveCSSD;

// {
//   "id": null,
//   "otDetails": {
//     "id": 1
//   },
//   "fromStore": 101,
//   "toStore": 102,
//   "itemDetailsRequestDtoList": [
//     {
//       "id": null,
//       "item": {
//         "id": 1001
//       },
//       "itemKit": {
//         "id": 2001
//       },
//       "transitQuantity": 10,
//       "discardedQuantity": 0,
//       "transferDate": "2025-07-18T10:00:00",
//       "transferQty": 10,
//       "transferStatus": true,
//       "transferredBy": {
//         "id": 501
//       },
//       "issueDate": "2025-07-18T10:15:00",
//       "issueStatus": true,
//       "issueQty": true,
//       "issuedBy": {
//         "id": 502
//       },
//       "receiveDate": "2025-07-18T11:00:00",
//       "receiveQty": 10,
//       "receiveStatus": true,
//       "receivedBy": {
//         "id": 503
//       },
//       "cleaningStatus": true,
//       "decontaminationStatus": true,
//       "cleanedQty": 10,
//       "cleanedBy": {
//         "id": 504
//       },
//       "cleaningStartDate": "2025-07-18T11:30:00",
//       "cleaningEndDate": "2025-07-18T12:00:00",
//       "wrappedQty": 10,
//       "wrappingStatus": true,
//       "wrappedBy": {
//         "id": 505
//       },
//       "wrapperType": {
//         "id": 1
//       },
//       "wrappingMethod": {
//         "id": 1
//       },
//       "wrappingStartDate": "2025-07-18T12:15:00",
//       "wrappingEndDate": "2025-07-18T12:45:00",
//       "sterilizationQty": 10,
//       "sterilizationStatus": true,
//       "sterilizationStatusType": "PASS",
//       "sterilizationStartBy": {
//         "id": 506
//       },
//       "sterilizationStartDate": "2025-07-18T13:00:00",
//       "sterilizationEndDate": "2025-07-18T14:00:00",
//       "sterilizationEndBy": {
//         "id": 507
//       },
//       "machine": {
//         "id": 1
//       },
//       "sterilizationType": {
//         "id": 1
//       },
//       "sterilizationMethod": {
//         "id": 1
//       },
//       "sterilizationExpiryDate": "2025-07-25T00:00:00",
//       "addToStockQty": 10,
//       "temperature": 134,
//       "pressure": 2,
//       "durationMinutes": 60,
//       "indicatorResult": "PASS"
//     }
//   ]
// }

// {
//     "Sr No": 1,
//     "Id": 15,
//     "Created Date": "2025-07-22 19:02:43.614507",
//     "Last Modified Date": "2025-07-22 19:02:43.614507",
//     "Created By": null,
//     "Last Modified By": 2599,
//     "Item Id": 10707,
//     "Item Code": "010449",
//     "Item Name": "Tissue Forceps, Allis, 6\"",
//     "Item Kit Code": 20,
//     "Item Kit Name": "LAPROSCOPY KIT",
//     "Ot Details Id": 635,
//     "Receive Date": null,
//     "Status": null,
//     "Transfer Date": "2025-07-22 19:02:43.614507",
//     "Received By": null,
//     "Sent By": null,
//     "Cleaned Qty": null,
//     "Cleaning Status": "false",
//     "Decontamination Status": "false",
//     "Receive Qty": null,
//     "Sterilization Qty": null,
//     "Sterilization Status": "false",
//     "Transfer Qty": 1,
//     "Issue Date": null,
//     "Issue Qty": null,
//     "Issue Status": false,
//     "Issued By": null,
//     "Disposed Date": null,
//     "Disposed Qty": null,
//     "Disposed By": null,
//     "Disposed Reason": null,
//     "Wrapped Qty": null,
//     "Wrapping Status": "false",
//     "Cleaned By": null,
//     "Wrapped By": null,
//     "Sterilized By": null,
//     "Receive Status": false,
//     "Sterilization Status Type": null,
//     "Transfer Status": true,
//     "Sterilization End By": null,
//     "Sterilization Start By": null,
//     "Transferred By": 2599,
//     "Used Quantity": null,
//     "Sterilization ExpiryDate": null,
//     "AddToStock Qty": null,
//     "Cleaning Start Date": null,
//     "Cleaning End Date": null,
//     "Wrapping Start Date": null,
//     "Wrapping End Date": null,
//     "Sterilization Equipment Id": null,
//     "Machine Id": null,
//     "Machine Name": null,
//     "Sterilization Start Date": null,
//     "Sterilization End Date": null,
//     "Wrapper Type Id": null,
//     "Wrapper Type": null,
//     "Wrapping Method Id": null,
//     "Wrapping Method": null,
//     "Sterilization Equipment": null,
//     "Sterilization Method Id": null,
//     "Sterilization Method": null
// }